<template>
	<div class="page_content explore_entity_inside career" aria-label="Career Detail page">

    	<div class="row page-heading">
      		<div class="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-7 input module_heading" id="careerIntroTour">
        		<div class="module_icon ico-career"></div>
        		<template v-if="formattedCareer && formattedCareer.name">
        			<career-title class="title_container" :career="formattedCareer"></career-title>
        		</template>
      		</div>
      		<div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-5 px-0">
        		<!--
        		<b-dropdown :animation="animation" variant="link" no-caret class="create-section-menu">
          		<template slot="button-content">
            		<span class="icon-menu3x3"></span>
          		</template>
        		</b-dropdown>
        		-->
        		<div v-if="canAccessEditPage && showBackToResultButton" class="btn_container">
	  					<b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
	              <span class="btn_ic ic-back"></span>
	              <span class="btn_txt"> {{ deCamelCase() }} </span>
	            </b-btn>
	            <span v-if="showCalculateRequiredSkillOnResult && isStudentLogin && planningStream" style="font-size: 16px; margin-right: 8px; color: #157099; float: right; cursor: pointer;" :id="'skillProgressPopup_' + formattedCareer.uuid" @click="calculateSkillProgressClicked(formattedCareer, $event)">Calculate Required Skills</span>
	  				</div>
  			</div>
    	</div>


    	<div class="page_content_container">

        	<career-navigation :active="'detail'" :code="code" :cipCode="cipCode" :returnTo="returnTo"></career-navigation>

          <div v-if="isEMSIFeatureEnabled || isBGTFeatureEnabled || isLightcastFeatureEnabled" class="row pg_content">

						<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

              <div class="row pg_sec sec_filter">
                <div class="col-12 hd ace_sec_hd" aria-label="Filter by State or City">
                  <!--
                  <span class="ic icon-filter"></span>
                -->
                <h2>Filter by State or City</h2>
                <span class="hd_bdr"></span>
              </div>

              <div class="col-12">
                <b-input-group class="row frm_sec">
                  <div class="col-11 frm_fld_col">
                    <div class="row">
                      <div class="frm_fld state">
                        <label for="state">Select State</label>
                        <v-select class="select-field" :disabled="disableSelectState" v-model='selectedState'
                        :options='formattedGeoIdMap.stateGeoIds' placeholder="Select or Search for a State" :class="!selectedState ? 'no_value_selected' : ''"></v-select>
												<span class="fld_info">
			                    <span v-if="disableSelectState">To select state clear the city selection first</span>
			                  </span>
                      </div>

											<div class="frm_label">
                        <label>OR</label>
											</div>

                      <div class="frm_fld city">
                        <label for="city">Select City</label>
                        <v-select class="select-field" :disabled="disableSelectMetroArea" v-model='selectedMetroArea'
                        :options='formattedGeoIdMap.msaGeoIds' placeholder="Select or Search for a City" :class="!selectedMetroArea ? 'no_value_selected' : ''"></v-select>
												<span class="fld_info">
			                    <span v-if="disableSelectMetroArea">To select city clear the state selection first</span>
			                  </span>
											</div>

											<!--
                      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 frm_fld county">
                        <label for="county">County</label>
                        <v-select class="select-field" :disabled="disableSelectCounty" v-model='selectedCounty'
                        :options='formattedGeoIdMap.countyGeoIds' placeholder="Select Any County"></v-select>
                      </div>
											-->

                    </div>
                  </div>

                  <div class="col-1 frm_btn_col">
                    <b-btn @click="careerSearchClicked" aria-label="Go">Go</b-btn>
                  </div>

                </b-input-group>
              </div>
            </div>

            <!-- Job Posting -->
            <div v-if="career && career.uuid" class="row pg_sec" :class="selectedMetroArea ? 'city_data_selected' : ''">
							<div class="col-12">

								<div class="row">
		              <div class="col-12 hd ace_sec_hd" aria-label="Career Outlook">
		                <h2>Career Outlook</h2>
		                <span class="hd_bdr"></span>
		              </div>
								</div>


								<div class="row content_sec jobs_outlook national_data" style="background: rgb(245, 245, 245);">

									<div class="card col-4 salary" v-if="formattedCareer && formattedCareer.medianIncomePerYear">
										<div class="card-body">
											<div class="crd_data">
												<div class="crd_data_inner">
													<div class="ic_container">
														<div class="ic ic8-salary"></div>
													</div>
													<div class="values">
														<div class="main_val_1" :aria-label="'Median Income $ ' + addCommaInNumber(career.medianIncomePerYear)">
															<template v-if="formattedCareer && formattedCareer.medianIncomePerYear">
																<div class="val_1_txt salary">
																	$<span v-html="addCommaInNumber(formattedCareer.medianIncomePerYear)"></span>
																</div>
															</template>
															<template v-else-if="careerOneStopInfo && careerOneStopInfo.medianEarning">
																<div class="val_1_txt salary">
																	$<span v-html="addCommaInNumber(careerOneStopInfo.medianEarning)"></span>
																</div>
															</template>
														</div>
                            <div class="add_val" v-if="formattedCareer.annualEarning90thPercentile">
                              hi - $<span v-html="addCommaInNumber(formattedCareer.annualEarning90thPercentile)"></span>
                            </div>
														<div class="add_val" v-else>
                              hi - <span class="info_no_val">N/A</span>
                            </div>
                            <div class="add_val" v-if="formattedCareer.annualEarning10thPercentile">
                              low - $<span v-html="addCommaInNumber(formattedCareer.annualEarning10thPercentile)"></span>
                            </div>
														<div class="add_val" v-else>
                              low - <span class="info_no_val">N/A</span>
                            </div>
													</div>
											 </div>
											</div>
											<div class="crd_title">
												<span class="title_txt">
													<span class="ic">
														<span class="ic8-salary"></span>
													</span>
													<span class="txt">
														<span class="txt_1">Median </span>
														<span class="txt_2">Income</span>
													</span>
												</span>
											</div>
										</div>
									</div>

									<div class="card col-4" v-if="formattedCareer && formattedCareer.growth">
										<div class="card-body">
											<template v-if="!selectedMetroArea">
												<div class="crd_data" :aria-label="'Estimated Job Growth in 2023-2033 ' + career.growth + '%'">
													<div class="row">
														<div class="col-xl-7 col-lg-6 col-md-12 col-sm-12 chart_container">
															<div class="row legend">
																<div class="col-6 lg_lft">0%</div>
																<div class="col-6 lg_rgt">15%</div>
															</div>
															<div class="gph_chart gph_pie_chart">
																<template v-if="formattedCareer && formattedCareer.growth">
																	<doughnut-chart :chart-data="growthPieData" id="bgt-gauge" :options="growthPieOptions" @afterComplete="callDrawNeedle('bgt-gauge', formattedCareer.growth)" :key="growthComponentKey"></doughnut-chart>
																</template>
																<template v-else-if="careerOneStopInfo && careerOneStopInfo.growth">
																	<doughnut-chart :chart-data="growthPieData" id="bgt-cos-gauge" :options="growthPieOptions" @afterComplete="callDrawNeedle('bgt-cos-gauge', careerOneStopInfo.growth)" :key="growthComponentKey"></doughnut-chart>
																</template>
															</div>
														</div>
														<div class="col-xl-5 col-lg-6 col-md-12 col-sm-12 main_val_1 gph_val" style="margin-top: -4px;">
															<div v-if="formattedCareer && formattedCareer.growth" class="gph_val pie_chart_val">
				                        <span class="val_1_txt" v-html="(Math.round(formattedCareer.growth * 100) / 100).toFixed(1)"></span><span>%</span>
				                      </div>
				                      <div v-else-if="careerOneStopInfo && careerOneStopInfo.growth" class="gph_val pie_chart_val">
				                        <span class="val_1_txt" v-html="(Math.round(careerOneStopInfo.growth * 100) / 100).toFixed(1)"></span><span>%</span>
				                      </div>
														</div>
													</div>
												</div>
												<div class="crd_title">
													<span class="title_txt">
														<span class="txt_1">Estimated Job Growth </span>
														<span class="txt_2">2023-2033</span>
												 </span>
												</div>
											</template>
											<template v-else>
												<div class="no_data_layer" v-if="selectedMetroArea">
													Data not available
												</div>
												<div class="crd_data no_data" aria-label="No data available">
													<div class="row">
														<div class="col-xl-7 col-lg-6 col-md-12 col-sm-12 chart_container">
															<div class="row legend">
																<div class="col-6 lg_lft">0%</div>
																<div class="col-6 lg_rgt">15%</div>
															</div>
															<div class="gph_chart gph_pie_chart">

															</div>
														</div>
														<div class="col-xl-5 col-lg-6 col-md-12 col-sm-12 main_val_1 gph_val" style="margin-top: -4px;">
															<div class="gph_val pie_chart_val">
				                        <span class="val_1_txt" v-html="'0.0%'"></span>
				                      </div>
				                    </div>
													</div>
												</div>
												<div class="crd_title">
													<span class="title_txt" style="color: rgb(210, 210, 210);">
														<span class="txt_1">Estimated Job Growth </span>
														<span class="txt_2">2023-2033</span>
												 </span>
												</div>
											</template>
										</div>
									</div>

									<div class="card col-4 postings" v-if="formattedCareer && formattedCareer.openings">
										<div class="card-body">
											<div class="crd_data">
												<div class="crd_data_inner" v-if="formattedCareer && formattedCareer.openings" :aria-label="'job postings in between 2023 to 2033 ' + addCommaInNumber(formattedCareer.openings)">
													<div class="ic_container">
														<div class="ic ic8-job2"></div>
													</div>
													<div class="values">
														<div class="main_val_1">
															<template v-if="formattedCareer && formattedCareer.openings">
				                        <div class="val_1_txt">
				                          <span v-html="formatNumericVal(formattedCareer.openings)"></span>
				                        </div>
					                    </template>
															<template v-else-if="careerOneStopInfo && careerOneStopInfo.openings">
				                        <div class="val_1_txt">
				                          <span v-html="formatNumericVal(careerOneStopInfo.openings)"></span>
				                        </div>
					                    </template>
														</div>
													</div>
											 </div>
											</div>
											<div class="crd_title">
												<span class="title_txt">
													<span class="ic">
														<span class="ic8-job2"></span>
													</span>
													<span class="txt">
														<span class="txt_1">Job Postings </span>
														<span class="txt_2">2023 - 2033</span>
													</span>
												</span>
											</div>
										</div>
									</div>

								</div>

							</div>
            </div>

						<!--
						<div class="row pg_sec" v-if="formattedCareer.formattedOccupation">
              <div class="col-12 hd ace_sec_hd" aria-label="Occupation Overview">
                <h2>Occupation Overview</h2>
                <span class="hd_bdr"></span>
              </div>

							<div class="col-12">
							<div class="row sec_content">
									<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 tbl_sec">

									<div class="row sec_info_bar" style="margin-bottom: 20px;">

                  <div class="col-3 list_info_row ace_sec_txt" :aria-label="'Occupation Year ' + formattedCareer.formattedOccupation.year">
										<div class="into_title" style="text-align: center;">Occupation Year</div>
                    <div class="info_val" style="text-align: center;">
                      <span>{{formattedCareer.formattedOccupation.year}}</span>
                    </div>
                  </div>
                  <div class="col-3 list_info_row ace_sec_txt" :aria-label="'Jobs ' + formattedCareer.formattedOccupation.lastYearJob">
										<div class="into_title" style="text-align: center;">Jobs</div>
									  <div class="info_val" style="text-align: center;">
											<span v-html="addCommaInNumber(formattedCareer.formattedOccupation.lastYearJob)"></span>
										</div>
                  </div>
                  <div class="col-3 list_info_row ace_sec_txt">
										<div class="into_title" style="text-align: center;" :aria-label="'change ' + formattedCareer.formattedOccupation.timeframe" tabindex="0"> % change / {{formattedCareer.formattedOccupation.timeframe}}</div>
                    <div class="info_val" :style="{'color': (formattedCareer.formattedOccupation.growth > 0 ? '#07d807' : 'red')}" :aria-label="formattedCareer.formattedOccupation.growth" tabindex="0">{{formattedCareer.formattedOccupation.growth}}</div>
                  </div>
                  <div class="col-3 list_info_row ace_sec_txt" :aria-label="'Median Earnings ' + formattedCareer.formattedOccupation.medianHourlyEarning">
										<div class="into_title" style="text-align: center;"> Median Earnings</div>
									  <div class="info_val" style="text-align: center;">
										$<span v-html="addCommaInNumber(formattedCareer.formattedOccupation.medianHourlyEarning)"></span>
										</div>
                  </div>
                </div>

              </div>
            </div>
						</div>
					</div>
					-->

					<!--
					==================================================================================
					==================================================================================
					T0 Do -- Neeraj [31 Jan 2020]
					Hide video section as whole page is display, work on this after release
					==================================================================================
					==================================================================================
					-->

					<div class="row pg_sec" v-if="!hideTopCompanies && topCompaniesItems && topCompaniesItems.length > 0">
						<div class="col-12 hd ace_sec_hd" aria-label="Top Companies Posting">
							<h2>Top Companies Posting</h2>
							<span class="hd_bdr"></span>
						</div>

						<div class="col-12 sec_content">
							<div class="row">

								<!--
								ToDo - Neeraj [07 Feb 2020]: Limit the result size upto 10 by chart.scss file for now,
								need to make it configurable under admin settings to update the size of chart
								-->
								<div class="col-12 gph_sec ace_sec" aria-label="Top Companies Posting Chart" style="max-width: 96%; margin-left: 2%;">
									<div class="time_chart_container chart_companies_posting">
										<div class="row">
											<template v-for="(topCompaniesItems, index) in topCompaniesItems">
												<div class="col-12 bar_block ace_sec">

													<b-popover :target="'popoverTarget_' + index" triggers="hover" placement="top" class="tooltip_popover" container="companiesPostingToolTip">
														<div class="tooltip_row">
															<div class="hd_txt"><span class="hd_txt" v-html="checkForCompanyName(topCompaniesItems.Company)"></span></div>
														</div>
														<div class="tooltip_row">
														    <div class="label">Postings</div>
															<div class="val"><span v-html="addCommaInNumber(topCompaniesItems.Total)"></span></div>
														</div>
														<!--
														<div class="tooltip_row">
															<div class="val">{{topCompaniesItems.Unique}}</div>
															<div class="label">Unique Postings</div>
														</div-->
													</b-popover>

													<div id="companiesPostingToolTip" class="chart_tooltip_popover"></div>

													<div class="bar_block_inner" :id="'popoverTarget_' + index">
														<div class="row">
															<div class="col-12 bar_title"><span v-html="checkForCompanyName(topCompaniesItems.Company)"></span></div>
															<div class="col-12 bar_val_1">Postings <span v-html="addCommaInNumber(topCompaniesItems.Total)"></span></div>
														</div>
													</div>

												</div>
											</template>
										</div>
									</div>
								</div>

								<!--
								<div class="col-12 tbl_sec">
									<b-table :items="topCompaniesItems" :fields="topCompaniesFields"/>
								</div>
								-->

							</div>
						</div>
					</div>


					<div class="row pg_sec" v-if="topSkillsItems && topSkillsItems.length > 0">
						<div class="col-12 hd ace_sec_hd" aria-label="Top In-Demand Skills within Job Postings">

							<div class="row">
								<div class="col-11">
								<h2>Top In-Demand Skills within Job Postings</h2>
								<span class="hd_bdr"></span>
							</div>
							<div class="col-1">
								<div class="tags_legend_icon" id="popoverTarget2_skillTags" style="margin-right: 19px; margin-top: -2px;">
									<div class="ic ic8-info5"></div>
								</div>
								<b-popover ref="skillTagsLegendsPopover" target="popoverTarget2_skillTags" triggers="click" placement="left" class="chart_tooltip_popover" container="skillsTagsLagends">
									<div class="tooltip_row tag_skill">
										<div class="popup_hd row">
											<div class="hd_txt col-11">
												Types of Skills
											</div>
											<div class="btn_container col-1">
												<button class="btn_close" aria-label="close" @click="closeSkillTagsLegendsPopup">
													<span class="ic-close"></span>
												</button>
											</div>
										</div>
										<div class="skill_tag_row">
											<div class="tag ace_sec_txt baselineSkills">F</div>
											<div class="tag_detail">
												<span class="tag_type_title">Foundational Skill:</span>
												Important skills that cross industries and occupations, such as organizational skills, communication skills, and project management, etc
											</div>
										</div>
										<!--
										<span class="skill_tag_row">
											<span class="tag ace_sec_txt definingSkills">D</span> Defining Skill
										</span>
										<span class="skill_tag_row">
											<span class="tag ace_sec_txt necessarySkills">N</span> Necessary Skill
										</span>
                    <span class="skill_tag_row">
											<span class="tag ace_sec_txt distinguishingSkills" style="width: 38px;">Dis</span> Distinguishing Skill
										</span>
                    -->
										<div class="skill_tag_row">
											<div class="tag ace_sec_txt specializedSkills">S</div>
											<div class="tag_detail">
												<span class="tag_type_title">Specialized Skill:</span>
												Occupation-specific skills identified in job postings, such as accounting, python programming, informatics, cybersecurity, etc.
											</div>
										</div>
										<div class="skill_tag_row">
											<div class="tag ace_sec_txt salaryBoostSkills">$</div>
											<div class="tag_detail">
												<span class="tag_type_title">Salary Boost Skill:</span>
												High demand skills that may provide a salary boost in an occupation
											</div>
										</div>
									</div>
								</b-popover>

								<div id="skillsTagsLagends" class="chart_tooltip_popover"></div>
							</div>
							</div>

            </div>

						<div class="col-12 sec_content" style="overflow: hidden;">
							<div class="row">
								<!--
								ToDo - Neeraj [07 Feb 2020]: Limit the result size upto 10 by chart.scss file for now,
								need to make it configurable under admin settings to update the size of chart
								-->
								<div class="col-12 gph_sec ace_sec gph_sec_skills" aria-label="Top Companies Posting Chart" style="max-width: 96%; margin-left: 2%;">
									<div class="time_chart_container chart_skills" id="careerDetailsSkills">

										<div class="row" v-if="isBGTFeatureEnabled || isLightcastFeatureEnabled">
											<template v-if="isSalaryBoostSkill">
												<div class="col-12 lnk_skill" style="padding-right: 5px; margin-top: -12px;">
													<div class="lnk_boost_skills">
														<b-link @click="showSalaryBoostSkills">Show Salary Boost Skills</b-link>
													</div>
													<div class="lnk_all_skills">
														<b-link @click="showAllSkills">Show All Skills</b-link>
													</div>
												</div>
											</template>
										</div>

										<div class="row">
											<template v-for="(topSkillsItems, index) in topSkillsItems">
												<div class="col-12 bar_block ace_sec"
												:class="'bar_block_' + index + ' ' + topSkillsItems.Types"
												:aria-label="topSkillsItems.Postings_with_Skill + ' Postings in ' + topSkillsItems.Skill">

												<b-popover :target="'popoverTarget2_skill_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="skillsToolTip">
													<div class="tooltip_row">
														<div class="label">Skill</div>
														<div class="val">{{topSkillsItems.Skill}}</div>
													</div>
													<div class="tooltip_row">
														<div class="label">Postings</div>
														<div class="val"><span v-html="addCommaInNumber(topSkillsItems.Postings_with_Skill)"></span></div>
													</div>
                          <div class="tooltip_row tag_skill">
                            <template v-for="type in topSkillsItems.Types">
															<span v-if="type === 'baselineSkills'" class="skill_tag_row">
																<span class="tag ace_sec_txt" :class="type">F</span> Foundational Skill
															</span>
                              <!--
															<span v-if="type === 'definingSkills'" class="skill_tag_row">
																<span class="tag ace_sec_txt" :class="type">D</span> Defining Skill
															</span>
															<span v-if="type === 'necessarySkills'" class="skill_tag_row">
																<span class="tag ace_sec_txt" :class="type">N</span> Necessary Skill
															</span>
															<span v-if="type === 'distinguishingSkills'" class="skill_tag_row">
																<span class="tag ace_sec_txt" :class="type">Dis</span> Distinguishing Skill
															</span>
                              -->
															<span v-if="type === 'specializedSkills'" class="skill_tag_row">
																<span class="tag ace_sec_txt" :class="type">S</span> Specialized Skill
															</span>
															<span v-if="type === 'salaryBoostSkills'" class="skill_tag_row">
																<span class="tag ace_sec_txt" :class="type" style="margin-top: -3px; float: left;">$</span> Salary Boost Skill
															</span>
                            </template>
                          </div>
                          <div class="tooltip_row" v-if="(isBGTFeatureEnabled || isLightcastFeatureEnabled) && topSkillsItems.Marginal_Value !== 'null' && topSkillsItems.Marginal_Value && topSkillsItems.Marginal_Value !== ''">
                            $<span v-html="addCommaInNumber(topSkillsItems.Marginal_Value)"></span>/Year
                          </div>
												</b-popover>

												<div id="skillsToolTip" class="chart_tooltip_popover"></div>

												<div class="bar_block_inner" :id="'popoverTarget2_skill_' + index">
													<div class="row" style="height: 100%;">
														<div class="col-8">

															<table class="lft_col">
																<tr>
																	<td>
																		<div class="bar_title">{{ topSkillsItems.Skill }} </div>
																	</td>
																</tr>

																<tr>
																	<td>
																		<div class="tag_skill">
				                              <template v-for="type in topSkillsItems.Types">
																				<span class="tag ace_sec_txt" :class="type" v-if="type === 'baselineSkills'" title="Foundational Skill">F</span>
					                              <!--<span class="tag ace_sec_txt" :class="type" v-if="type === 'definingSkills'" title="Defining Skill">D</span>
					                              <span class="tag ace_sec_txt" :class="type" v-if="type === 'necessarySkills'" title="Necessary Skill">N</span>
					                              <span class="tag ace_sec_txt" :class="type" v-if="type === 'distinguishingSkills'" title="Distinguishing Skill">Dis</span>-->
					                              <span class="tag ace_sec_txt" :class="type" v-if="type === 'specializedSkills'" title="Specialized Skill">S</span>
					                              <span class="tag ace_sec_txt" :class="type" v-if="type === 'salaryBoostSkills'" title="Salary Boost Skill" :id="setSkillRowClass(type)">$</span>
																			</template>
				                            </div>
																	</td>
																</tr>
															</table>

														</div>
														<div class="col-4 rgt_col">
															<table class="posting">
																<tr>
																	<td>
																		<span class="bar_val_1">
																			Postings <span v-html="addCommaInNumber(topSkillsItems.Postings_with_Skill)"></span>
																		</span>
																	</td>
																</tr>

																<tr v-if="(isBGTFeatureEnabled || isLightcastFeatureEnabled) && topSkillsItems.Marginal_Value !== 'null' && topSkillsItems.Marginal_Value && topSkillsItems.Marginal_Value !== ''">
																	<td>
																		<span class="bar_val_1 val_salary_boost" style="text-align: right;">
				                              $<span v-html="addCommaInNumber(topSkillsItems.Marginal_Value)" style="display: inline;"></span>/Year
				                            </span>
																	</td>
																</tr>
															</table>

														</div>
													</div>
												</div>

												<template v-if="formattedCareer && formattedCareer.openings">
		                      <div class="bar" v-bind:style="{width:setSkillsBarWidth(formattedCareer.openings, topSkillsItems.Postings_with_Skill)}"></div>
												</template>
												<template v-else-if="careerOneStopInfo && careerOneStopInfo.openings">
													<div class="bar" v-bind:style="{width:setSkillsBarWidth(careerOneStopInfo.openings, topSkillsItems.Postings_with_Skill)}"></div>
												</template>

												</div>
											</template>
										</div>
									</div>
								</div>

								<!--
								<div class="col-12 tbl_sec">
									<b-table :items="topSkillsItems" :fields="topSkillsFields"/>
								</div>
							-->

							</div>
						</div>
					</div>



          <!-- Growth Chart for LightCast -->
					<div class="row pg_sec" v-if="isLightcastFeatureEnabled && formattedCareer.growth && chartDataReady">
						<div class="col-12 hd ace_sec_hd" aria-label="Growth">
							<h2>Growth</h2>
							<span class="hd_bdr"></span>
						</div>

						<div class="col-12 gph_sec ace_sec" aria-label="Growth Chart" style="margin-left: -15px; max-width: 103%; flex: 0 0 103%;">
              <LineChart :data="chartData" :options="chartOptions" />
              <!--
							<div class="bar_chart_container bar_label_inside chart_annual_wage_percentiles">
								<div v-if="formattedCareer.growthOneYear" class="row bar_row ace_sec" :aria-label="'Growth in One Year ' + formattedCareer.growthOneYear">
									<div class="col-12">

										<div id="annualWagePercentilesToolTip" class="chart_tooltip_popover"></div>
										<b-popover :target="'popoverGrowth_0'" triggers="hover" placement="top" class="chart_tooltip_popover" container="annualWagePercentilesToolTip">
											<div class="tooltip_row">

												<div class="label">Growth</div>

												<div class="val">One Year</div>
											</div>
											<div class="tooltip_row">
												<div class="val"><span v-html="formattedCareer.growthOneYear + '%'"></span></div>
											</div>
										</b-popover>

										<div class="bar_container" :id="'popoverGrowth_0'">
											<div class="bar_label">One Year </div>
											<div class="bar_val"><span v-html="formattedCareer.growthOneYear + '%'"></span></div>
											<div class="bar" v-bind:style="{width:getNumberFromValue(formattedCareer.growthOneYear) + '%'}"></div>
										</div>

									</div>
								</div>

                <div v-if="formattedCareer.growthTwoYear" class="row bar_row ace_sec" :aria-label="'Growth in Two Year ' + formattedCareer.growthTwoYear">
									<div class="col-12">

										<div id="annualWagePercentilesToolTip" class="chart_tooltip_popover"></div>
										<b-popover :target="'popoverGrowth_1'" triggers="hover" placement="top" class="chart_tooltip_popover" container="annualWagePercentilesToolTip">
											<div class="tooltip_row">

												<div class="label">Growth</div>

												<div class="val">Two Year</div>
											</div>
											<div class="tooltip_row">
												<div class="val"><span v-html="formattedCareer.growthTwoYear + '%'"></span></div>
											</div>
										</b-popover>

										<div class="bar_container" :id="'popoverGrowth_1'">
											<div class="bar_label">Two Year </div>
											<div class="bar_val"><span v-html="formattedCareer.growthTwoYear + '%'"></span></div>
											<div class="bar" v-bind:style="{width:getNumberFromValue(formattedCareer.growthTwoYear) + '%'}"></div>
										</div>

									</div>
								</div>

                <div v-if="formattedCareer.growthThreeYear" class="row bar_row ace_sec" :aria-label="'Growth in Three Year ' + formattedCareer.growthThreeYear">
									<div class="col-12">

										<div id="annualWagePercentilesToolTip" class="chart_tooltip_popover"></div>
										<b-popover :target="'popoverGrowth_2'" triggers="hover" placement="top" class="chart_tooltip_popover" container="annualWagePercentilesToolTip">
											<div class="tooltip_row">

												<div class="label">Growth</div>

												<div class="val">Three Year</div>
											</div>
											<div class="tooltip_row">
												<div class="val"><span v-html="formattedCareer.growthThreeYear + '%'"></span></div>
											</div>
										</b-popover>

										<div class="bar_container" :id="'popoverGrowth_2'">
											<div class="bar_label">Three Year </div>
											<div class="bar_val"><span v-html="formattedCareer.growthThreeYear + '%'"></span></div>
											<div class="bar" v-bind:style="{width:getNumberFromValue(formattedCareer.growthThreeYear) + '%'}"></div>
										</div>

									</div>
								</div>

                <div v-if="formattedCareer.growthFiveYear" class="row bar_row ace_sec" :aria-label="'Growth in Five Year ' + formattedCareer.growthFiveYear">
									<div class="col-12">

										<div id="annualWagePercentilesToolTip" class="chart_tooltip_popover"></div>
										<b-popover :target="'popoverGrowth_3'" triggers="hover" placement="top" class="chart_tooltip_popover" container="annualWagePercentilesToolTip">
											<div class="tooltip_row">

												<div class="label">Growth</div>

												<div class="val">Five Year</div>
											</div>
											<div class="tooltip_row">
												<div class="val"><span v-html="formattedCareer.growthFiveYear + '%'"></span></div>
											</div>
										</b-popover>

										<div class="bar_container" :id="'popoverGrowth_3'">
											<div class="bar_label">Five Year </div>
											<div class="bar_val"><span v-html="formattedCareer.growthFiveYear + '%'"></span></div>
											<div class="bar" v-bind:style="{width:getNumberFromValue(formattedCareer.growthFiveYear) + '%'}"></div>
										</div>

									</div>
								</div>

                <div v-if="formattedCareer.growthTenYear" class="row bar_row ace_sec" :aria-label="'Growth in Ten Year ' + formattedCareer.growthTenYear">
									<div class="col-12">

										<div id="annualWagePercentilesToolTip" class="chart_tooltip_popover"></div>
										<b-popover :target="'popoverGrowth_4'" triggers="hover" placement="top" class="chart_tooltip_popover" container="annualWagePercentilesToolTip">
											<div class="tooltip_row">

												<div class="label">Growth</div>

												<div class="val">Ten Year</div>
											</div>
											<div class="tooltip_row">
												<div class="val"><span v-html="formattedCareer.growthTenYear + '%'"></span></div>
											</div>
										</b-popover>

										<div class="bar_container" :id="'popoverGrowth_4'">
											<div class="bar_label">Ten Year </div>
											<div class="bar_val"><span v-html="formattedCareer.growthTenYear + '%'"></span></div>
											<div class="bar" v-bind:style="{width:getNumberFromValue(formattedCareer.growthTenYear) + '%'}"></div>
										</div>

									</div>
								</div>

							</div>
              -->
						</div>

					</div>
					<!-- Growth Chart -->

					<!-- Annual Wage Percentiles Chart -->
					<div class="row pg_sec" v-if="careerOneStopInfo && careerOneStopInfo.annualWagePercentiles">
						<div class="col-12 hd ace_sec_hd" aria-label="Annual Wage Percentiles">
							<h2>Annual Wage Percentiles</h2>
							<span class="hd_bdr"></span>
						</div>

						<div class="col-12 gph_sec ace_sec" aria-label="Annual Wage Percentiles Chart" style="margin-left: -15px; max-width: 103%; flex: 0 0 103%;">
							<div class="bar_chart_container bar_label_inside chart_annual_wage_percentiles">
								<template v-for="(wage, index) in careerOneStopInfo.annualWagePercentiles">
									<div class="row bar_row ace_sec" :aria-label="'Annual Wage Percentiles for ' + wage.key + ' is ' + wage.value">
										<div class="col-12">

											<div id="annualWagePercentilesToolTip" class="chart_tooltip_popover"></div>
											<b-popover :target="'popoverAnnualWage_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="annualWagePercentilesToolTip">
												<div class="tooltip_row">

													<div class="label">Wage Percentiles</div>

													<div class="val">{{ wage.key }}</div>
												</div>
												<div class="tooltip_row">
													<div class="val"><span v-html="'$' + addCommaInNumber(wage.value)"></span></div>
												</div>
											</b-popover>

											<div class="bar_container" :id="'popoverAnnualWage_' + index">
												<div class="bar_label">{{ wage.key }} </div>
												<div class="bar_val"><span v-html="'$' + addCommaInNumber(wage.value)"></span></div>
												<div class="bar" v-bind:style="{width:getNumberFromValue(wage.key) + '%'}"></div>
											</div>

										</div>
									</div>
								</template>
							</div>
						</div>

					</div>
					<!-- Annual Wage Percentiles Chart -->

          <!-- Annual Wage Percentiles Chart for LightCast -->
					<div class="row pg_sec" v-if="isLightcastFeatureEnabled && formattedCareer.medianIncomePerYear">
						<div class="col-12 hd ace_sec_hd" aria-label="Annual Wage Percentiles">
							<h2>Annual Wage Percentiles</h2>
							<span class="hd_bdr"></span>
						</div>

						<div class="col-12 gph_sec ace_sec" aria-label="Annual Wage Percentiles Chart" style="margin-left: -15px; max-width: 103%; flex: 0 0 103%;">
							<div class="bar_chart_container bar_label_inside chart_annual_wage_percentiles">
								<div v-if="formattedCareer.annualEarning10thPercentile" class="row bar_row ace_sec" :aria-label="'Annual Wage Percentiles for 10th Percentile is ' + formattedCareer.annualEarning10thPercentile">
									<div class="col-12">

										<div id="annualWagePercentilesToolTip" class="chart_tooltip_popover"></div>
										<b-popover :target="'popoverAnnualWage_0'" triggers="hover" placement="top" class="chart_tooltip_popover" container="annualWagePercentilesToolTip">
											<div class="tooltip_row">

												<div class="label">Wage Percentiles</div>

												<div class="val">10th Percentile</div>
											</div>
											<div class="tooltip_row">
												<div class="val"><span v-html="'$' + addCommaInNumber(formattedCareer.annualEarning10thPercentile)"></span></div>
											</div>
										</b-popover>

										<div class="bar_container" :id="'popoverAnnualWage_0'">
											<div class="bar_label">10th Percentile </div>
											<div class="bar_val"><span v-html="'$' + addCommaInNumber(formattedCareer.annualEarning10thPercentile)"></span></div>
											<div class="bar" v-bind:style="{width:getNumberFromValueAndDivideByThousand(formattedCareer.annualEarning10thPercentile) + '%'}"></div>
										</div>

									</div>
								</div>

                <div v-if="formattedCareer.annualEarning25thPercentile" class="row bar_row ace_sec" :aria-label="'Annual Wage Percentiles for 25th Percentile is ' + formattedCareer.annualEarning25thPercentile">
									<div class="col-12">

										<div id="annualWagePercentilesToolTip" class="chart_tooltip_popover"></div>
										<b-popover :target="'popoverAnnualWage_1'" triggers="hover" placement="top" class="chart_tooltip_popover" container="annualWagePercentilesToolTip">
											<div class="tooltip_row">

												<div class="label">Wage Percentiles</div>

												<div class="val">25th Percentile</div>
											</div>
											<div class="tooltip_row">
												<div class="val"><span v-html="'$' + addCommaInNumber(formattedCareer.annualEarning25thPercentile)"></span></div>
											</div>
										</b-popover>

										<div class="bar_container" :id="'popoverAnnualWage_1'">
											<div class="bar_label">25th Percentile </div>
											<div class="bar_val"><span v-html="'$' + addCommaInNumber(formattedCareer.annualEarning25thPercentile)"></span></div>
											<div class="bar" v-bind:style="{width:getNumberFromValueAndDivideByThousand(formattedCareer.annualEarning25thPercentile) + '%'}"></div>
										</div>

									</div>
								</div>

                <div v-if="formattedCareer.annualEarning50thPercentile" class="row bar_row ace_sec" :aria-label="'Annual Wage Percentiles for 50th Percentile is ' + formattedCareer.annualEarning50thPercentile">
									<div class="col-12">

										<div id="annualWagePercentilesToolTip" class="chart_tooltip_popover"></div>
										<b-popover :target="'popoverAnnualWage_2'" triggers="hover" placement="top" class="chart_tooltip_popover" container="annualWagePercentilesToolTip">
											<div class="tooltip_row">

												<div class="label">Wage Percentiles</div>

												<div class="val">50th Percentile</div>
											</div>
											<div class="tooltip_row">
												<div class="val"><span v-html="'$' + addCommaInNumber(formattedCareer.annualEarning50thPercentile)"></span></div>
											</div>
										</b-popover>

										<div class="bar_container" :id="'popoverAnnualWage_2'">
											<div class="bar_label">50th Percentile </div>
											<div class="bar_val"><span v-html="'$' + addCommaInNumber(formattedCareer.annualEarning50thPercentile)"></span></div>
											<div class="bar" v-bind:style="{width:getNumberFromValueAndDivideByThousand(formattedCareer.annualEarning50thPercentile) + '%'}"></div>
										</div>

									</div>
								</div>

                <div v-if="formattedCareer.annualEarning75thPercentile" class="row bar_row ace_sec" :aria-label="'Annual Wage Percentiles for 75th Percentile is ' + formattedCareer.annualEarning75thPercentile">
									<div class="col-12">

										<div id="annualWagePercentilesToolTip" class="chart_tooltip_popover"></div>
										<b-popover :target="'popoverAnnualWage_3'" triggers="hover" placement="top" class="chart_tooltip_popover" container="annualWagePercentilesToolTip">
											<div class="tooltip_row">

												<div class="label">Wage Percentiles</div>

												<div class="val">75th Percentile</div>
											</div>
											<div class="tooltip_row">
												<div class="val"><span v-html="'$' + addCommaInNumber(formattedCareer.annualEarning75thPercentile)"></span></div>
											</div>
										</b-popover>

										<div class="bar_container" :id="'popoverAnnualWage_3'">
											<div class="bar_label">75th Percentile </div>
											<div class="bar_val"><span v-html="'$' + addCommaInNumber(formattedCareer.annualEarning75thPercentile)"></span></div>
											<div class="bar" v-bind:style="{width:getNumberFromValueAndDivideByThousand(formattedCareer.annualEarning75thPercentile) + '%'}"></div>
										</div>

									</div>
								</div>

                <div v-if="formattedCareer.annualEarning90thPercentile" class="row bar_row ace_sec" :aria-label="'Annual Wage Percentiles for 90th Percentile is ' + formattedCareer.annualEarning90thPercentile">
									<div class="col-12">

										<div id="annualWagePercentilesToolTip" class="chart_tooltip_popover"></div>
										<b-popover :target="'popoverAnnualWage_4'" triggers="hover" placement="top" class="chart_tooltip_popover" container="annualWagePercentilesToolTip">
											<div class="tooltip_row">

												<div class="label">Wage Percentiles</div>

												<div class="val">90th Percentile</div>
											</div>
											<div class="tooltip_row">
												<div class="val"><span v-html="'$' + addCommaInNumber(formattedCareer.annualEarning90thPercentile)"></span></div>
											</div>
										</b-popover>

										<div class="bar_container" :id="'popoverAnnualWage_4'">
											<div class="bar_label">90th Percentile </div>
											<div class="bar_val"><span v-html="'$' + addCommaInNumber(formattedCareer.annualEarning90thPercentile)"></span></div>
											<div class="bar" v-bind:style="{width:getNumberFromValueAndDivideByThousand(formattedCareer.annualEarning90thPercentile) + '%'}"></div>
										</div>

									</div>
								</div>
							</div>
						</div>

					</div>
					<!-- Annual Wage Percentiles Chart -->

					<div class="row pg_sec" v-if="educationItems && educationItems.length > 0">
						<div class="col-12 hd ace_sec_hd" aria-label="National Educational Attainment">
							<h2>National Educational Attainment</h2>
							<span class="hd_bdr"></span>
						</div>

						<div class="col-12 gph_sec ace_sec" aria-label="National Educational Attainment Chart">
							<div class="bar_chart_container bar_label_inside chart_national_educational_attainment">
								<template v-for="(educationItems, index) in educationItems">
									<div class="row bar_row ace_sec" :aria-label="'National Educational Attainment for ' + educationItems.Education_Level + ' is ' + educationItems.Percent + '%.'">

										<div id="educationalAgeToolTip" class="chart_tooltip_popover"></div>

										<div class="col-12 bar_container" :id="'popoverEducation_' + index">
											<div class="bar_label">{{ educationItems.Education_Level }} </div>
											<div class="bar_val"><span v-html="formatDecimalValue(educationItems.Percent) + '%'"></span></div>
											<div class="bar" v-bind:style="{width:educationItems.Percent + '%'}"></div>

												<b-popover :target="'popoverEducation_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="educationalAgeToolTip">
													<div class="tooltip_row">
														<div class="label">Education Level</div>
														<div class="val">{{ educationItems.Education_Level }}</div>
													</div>
													<div class="tooltip_row">

														<div class="val">{{ educationItems.Percent }}%</div>
													 </div>

												</b-popover>
										</div>

									</div>
								</template>
							</div>
						</div>

						<!--
						<div class="col-12 sec_content">
							<div class="row">
								<div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 gph_sec ace_sec" aria-label="Education graph section">
									<vc-donut v-if="educationDonutChartItems && educationDonutChartItems.length > 0" has-legend :size="educationDonutChartSize" :unit="px" :sections="educationDonutChartItems"></vc-donut>
								</div>
								<div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 tbl_sec">
									<div v-if="educationItems && educationItems.length > 0">
										<div class="table-container ace_sec" aria-label="Education Field items">
											<b-table :items="educationItems" :fields="educationFields"/>
										</div>
									</div>
								</div>
							</div>
						</div>
						-->

					</div>

          <div class="row pg_sec" v-if="experienceItems && experienceItems.length > 0">
						<div class="col-12 hd ace_sec_hd" aria-label="Experience">
							<h2>Experience</h2>
							<span class="hd_bdr"></span>
						</div>

						<div class="col-12 gph_sec ace_sec" aria-label="Experience Chart">
							<div class="bar_chart_container bar_label_inside chart_national_educational_attainment">
								<template v-for="(experienceItem, index) in experienceItems">
									<div class="row bar_row ace_sec" :aria-label="'Experience for ' + experienceItem.Experience_Level + ' is ' + experienceItem.Percent + '%.'">

											 <div id="educationalAgeToolTip" class="chart_tooltip_popover"></div>
										<div class="col-12 bar_container" :id="'popoverEducation_' + index">
											<div class="bar_label">{{ experienceItem.Experience_Level }} </div>
											<div class="bar_val"><span v-html="formatDecimalValue(experienceItem.Percent) + '%'"></span></div>
											<div class="bar" v-bind:style="{width:experienceItem.Percent + '%'}"></div>

												<b-popover :target="'popoverExperience_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="educationalAgeToolTip">
													<div class="tooltip_row">
														<div class="label">Experience Level</div>
															<div class="val">{{ experienceItem.Education_Level }}</div>

													</div>
													<div class="tooltip_row">

														<div class="val">{{ experienceItem.Percent }}%</div>
													 </div>

												</b-popover>
										</div>

									</div>
								</template>
							</div>
						</div>

						<!--
						<div class="col-12 sec_content">
							<div class="row">
								<div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 gph_sec ace_sec" aria-label="Education graph section">
									<vc-donut v-if="educationDonutChartItems && educationDonutChartItems.length > 0" has-legend :size="educationDonutChartSize" :unit="px" :sections="educationDonutChartItems"></vc-donut>
								</div>
								<div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 tbl_sec">
									<div v-if="educationItems && educationItems.length > 0">
										<div class="table-container ace_sec" aria-label="Education Field items">
											<b-table :items="educationItems" :fields="educationFields"/>
										</div>
									</div>
								</div>
							</div>
						</div>
						-->

					</div>


          <div class="row pg_sec sec_certifications" v-if="career.certifications && career.certifications.length > 0">
						<div class="col-12 hd ace_sec_hd" aria-label="Experience">
							<h2>Certifications</h2>
							<span class="hd_bdr"></span>
						</div>

						<div class="col-12 list_view ace_sec table_v4" aria-label="Certifications Chart">

							<div class="row tbl_row" v-for="(c, index) in career.certifications">

								<!--
								<div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 thumbnail_section">
									<div class="thumbnail_container ace_sec">
										<div class="thumbnail_img" v-if="c.thumbnailURI">
											<img v-bind:src="c.thumbnailURI" alt="Img">
										</div>
										<div class="thumbnail" v-else>
											<div class="txt_bx" :id="setTitleBoxWidth(c.name, 'thumb_' + index)" v-html="setTitleInitials(c.name)"></div>
										</div>
									</div>
								</div>
								-->

								<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" :class="updateTitleHeight(index)">
									<div class="row">
										<div class="col-12">
											<span class="bar_label ace_sec_txt pl-3" :id="'entityName_' + index" :aria-label="c.name">{{c.name}}</span>

											<b-popover :target="'entityName_' + index" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer_' + index">
												<div class="title_container">
													{{c.name}}
												</div>
											</b-popover>
											<div :id="'entityNameContainer_' + index" class="title_container_popup"></div>

										</div>

										<!--
										<div class="col-12 description ace_sec_txt" :id="'entityDesc_' + index" v-if="c.description">
											 <span class="desc_txt">{{ c.description }}</span>
										</div>
										<div class="col-12 no_description empty_pattern ace_sec_txt" aria-label="No description added for this certification" v-else>
											 No description added for this certification
										</div>
										-->

									</div>
								</div>

							</div>


						</div>

					</div>


            <div class="row pg_sec"  v-if="occupationAgeItems && occupationAgeItems.length > 0">
              <div class="col-12 hd ace_sec_hd" aria-label="Occupation Age Breakdown">
                <h2>Occupation Age Breakdown</h2>
                <span class="hd_bdr"></span>
              </div>

              <div class="col-12 sec_content">
                <div class="row">

									<div class="col-12 gph_sec ace_sec" aria-label="Occupation Age Breakdown Chart">
										<div class="bar_chart_container bar_label_inside chart_age_breakdown">
											<template v-for="(occupationAgeItems, index) in occupationAgeItems">


												<div class="row bar_row ace_sec"   :aria-label="'Occupation Age Breakdown for group ' + occupationAgeItems.Age + ' is ' + occupationAgeItems.Percent + '%.'">

                                                 <div class="col-12">
												  <div id="occupationAgeToolTip" class="chart_tooltip_popover"></div>
													<div class="bar_container" :id="'popoverOccuption_' + index">
                                                         <div class="bar_label">{{ occupationAgeItems.Age }} </div>
                                                         <div class="bar_val">{{ occupationAgeItems.Percent }}% </div>
                                                         <div class="bar" v-bind:style="{width:occupationAgeItems.Percent + '%'}"></div>
                                                    </div>

											      <b-popover :target="'popoverOccuption_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="occupationAgeToolTip">
                                                    <div class="tooltip_row">
													     <div class="label">Age Group</div>
                                                        <div class="val">{{ occupationAgeItems.Age }}</div>

                                                    </div>
                                                    <div class="tooltip_row">

                                                        <div class="val">{{ occupationAgeItems.Percent }}%</div>

                                                     </div>

                                                </b-popover>
												</div>

												</div>

											</template>
										</div>
									</div>

									<!--
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 gph_sec ace_sec" aria-label="occupation graph section">
                    <vc-donut v-if="occupationAgeDonutChartItems && occupationAgeDonutChartItems.length > 0" has-legend :size="occupationAgeDonutChartSize" :unit="px" :sections="occupationAgeDonutChartItems"></vc-donut>
                  </div>
                  <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12 tbl_sec">
                    <div v-if="occupationAgeItems && occupationAgeItems.length > 0">
                      <div class="table-container ace_sec" aria-label="occupation age items">
                        <b-table :items="occupationAgeItems" :fields="occupationAgeFields"/>
                      </div>
                    </div>
                  </div>
									-->

                </div>
              </div>
            </div>


						<div class="row pg_sec" v-if="formattedCareer.percentByGenderWomen && formattedCareer.percentByGenderMen">
							<div class="col-12 hd ace_sec_hd" aria-label="Gender Breakdown">
								<h2>Gender Breakdown</h2>
								<span class="hd_bdr"></span>
							</div>

							<div class="col-12">
								<div class="row sec_content">

									<div class="col-3 gph_sec ace_sec" aria-label="gender graph section" style="margin-top: -4px;">
										<vc-donut v-if="genderDonutChartItems && genderDonutChartItems.length > 0" :size="genderDonutChartSize" :unit="px" :sections="genderDonutChartItems"></vc-donut>
									</div>

									<div class="col-9 gph_sec ace_sec" aria-label="Gender Breakdown Chart">
										<div class="bar_chart_container bar_label_inside chart_gender_breakdown">

												<div class="row bar_row ace_sec" :aria-label="'Gender breakdown for men is ' + formattedCareer.percentByGenderMen">
													<div class="col-12">
													<div id="menToolTip" class="chart_tooltip_popover"></div>
													 <div class="bar_container" id="popover_men">
																												<div class="bar_label">Men </div>
																													 <div class="bar_val"><span>{{ formattedCareer.percentByGenderMen }}%</span></div>
																													<div class="bar" v-bind:style="{width:formattedCareer.percentByGenderMen + '%'}"></div>
																											 </div>

																	<b-popover target="popover_men" triggers="hover" placement="top" class="chart_tooltip_popover" container="menToolTip">
																																<div class="tooltip_row">
																															 <div class="label">Men</div>
																																<div class="val">{{ formattedCareer.percentByGenderMen }}%</div>
																															 </div>

																														</b-popover>
															</div>
															 </div>

												<div class="row bar_row ace_sec" :aria-label="'Gender breakdown for women is ' + formattedCareer.percentByGenderWomen">

																									<div class="col-12">
													<div id="womenToolTip" class="chart_tooltip_popover"></div>
													 <div class="bar_container" id="popover_women">
																											 <div class="bar_label">Women</div>
																											 <div class="bar_val"><span>{{ formattedCareer.percentByGenderWomen }}% </span></div>
																											 <div class="bar" v-bind:style="{width:formattedCareer.percentByGenderWomen + '%'}"></div>
																										 </div>

													 <b-popover target="popover_women" triggers="hover" placement="top" class="chart_tooltip_popover" container="womenToolTip">
																										 <div class="tooltip_row">
																												<div class="label">Women</div>
																												<div class="val">{{ formattedCareer.percentByGenderWomen }}%</div>
																										 </div>
																									 </b-popover>
												</div>
																							 </div>
										</div>
									</div>



									<!--
									<div class="col-xl-9 col-lg-9 col-md-9 col-sm-12 tbl_sec">
										<div v-if="genderItems && genderItems.length > 0">

											<div class="table-container ace_sec" aria-label="gender fields">
												<b-table :items="genderItems" :fields="genderFields"/>
											</div>

										</div>
									</div>
										-->


								</div>
							</div>
						</div>

						<!--
						==================================================================================
						==================================================================================
						T0 Do -- Neeraj [31 Jan 2020]
						Hide Departments and Industries data for time being as need to plan the graphical representaion for these,
						Will enable these after 03 Feb 2020 release and update the UI
						==================================================================================
						==================================================================================
						-->

						<!--
						<div class="row pg_sec" v-if="formattedCareer.departmentsLabel && formattedCareer.departmentsLabel.length > 0">
              <div class="col-12 hd ace_sec_hd" aria-label="Departments">
                <h2>Departments</h2>
                <span class="hd_bdr"></span>
              </div>

              <div class="col-12 sec_content">
                <div class="row">
                  <div class="col-12 tbl_sec">
                    <div class="content-row ace_sec_txt" :aria-label="formattedCareer.departmentsLabel">{{formattedCareer.departmentsLabel}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row pg_sec" v-if="formattedCareer.industriesLabel && formattedCareer.industriesLabel.length > 0">
              <div class="col-12 hd ace_sec_hd" aria-label="Industries">
                <h2>Industries</h2>
                <span class="hd_bdr"></span>
              </div>

              <div class="col-12 sec_content">
                <div class="row">
                  <div class="col-12 tbl_sec">
                    <div class="content-row ace_sec_txt" :aria-label="formattedCareer.industriesLabel"> {{formattedCareer.industriesLabel}} </div>
                  </div>
                </div>
              </div>
            </div>
						-->

						<div class="col-12 data_source_info" v-if="isBGTFeatureEnabled">Data Source: Burning Glass Technologies.</div>
            <div class="col-12 data_souce_info" v-if="isLightcastFeatureEnabled">Data Source: Lightcast</div>

          </div> <!-- .content_mid_panel -->

					<!--<div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 content_rgt_panel">
						<div class="row">

							<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 thumbnail_container">

								<template v-if="careerOneStopInfo && careerOneStopInfo.videoURL">
									<b-modal class="video_popup" ref="videoModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc centered size="lg">
										<div class="btn_container">
											<button class="btn_close" @click="closeVideoPopup()" title="close">
												<span class="ic-close"></span>
											</button>
										</div>
										<template v-if="isVideoModalEnable">
											<video width="100%" controls autoplay>
												<source :src="careerOneStopInfo.videoURL" type="video/mp4">
											</video>
										</template>
									</b-modal>

									<div class="play_video" :class="formattedCareer.thumbnailURI ? '' : 'default_thumb_layer'">
										<span class="ic ic8-play2" @click="showVideoPopup()"></span>
									</div>
								</template>

								<img :src="formattedCareer.thumbnailURI"
									v-if="formattedCareer.thumbnailURI"
									onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';"
									tabindex="0">
								<div v-else class="thumbnail_default ico-career" aria-label="default career image" tabindex="0"></div>
							</div>

							<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 other_info">

								<div class="sec_hd row">
									<div class="col-10">
										<h3 class="ace_sec_hd">US Data</h3>
									</div>

									<div class="col-2 data_souce_info" style="margin-right: 0px; margin-top: -4px;">
										<div id="dataSouceInfo" style="float: right;">
											<span class="ic ic8-info5"></span>
										</div>
										<b-popover target="dataSouceInfo" container="dataSouceInfoPopup" triggers="hover" style="margin-top: 20px;">
											<div class="popup_content">
												{{careerDataSource}}
											</div>
										</b-popover>
										<div id="dataSouceInfoPopup"></div>
									</div>
								</div>

								<div v-if="showMedianIncome" class="list_info_row ace_sec_txt" :aria-label="'median income ' + currencyLabel + career.medianIncomePerYear">
									<div class="info_title lft_dir">{{medianIncomeLabel}}</div>
										<div class="info_val" v-if="career.medianIncomePerYear">
											{{currencyLabel}} <span v-html="addCommaInNumber(career.medianIncomePerYear)"></span>
										</div>
										<div class="info_no_val" v-else>N/A</div>
										<div class="info_title rgt_dir">{{medianIncomeLabel}}</div>
								</div>

								<div v-if="showJobPostings" class="list_info_row ace_sec_txt" :aria-label="'job postings ' + career.openings">
									<div class="info_title lft_dir">{{jobPostingsLabel}}</div>
										<div class="info_val" v-if="career.openings">
											<span v-html="addCommaInNumber(career.openings)"></span>
										</div>
										<div class="info_no_val" v-else>N/A</div>
										<div class="info_title rgt_dir">{{jobPostingsLabel}}</div>
								</div>

								<div v-if="showGrowthRate" class="list_info_row ace_sec_txt" :aria-label="'growth rate ' + career.growth">
									<div class="info_title lft_dir">{{growthRateLabel}}</div>
										<div class="info_val" v-if="career.growth" :title="career.growth">{{career.growth}}%</div>
										<div class="info_no_val" v-else>N/A</div>
										<div class="info_title rgt_dir">{{growthRateLabel}}</div>
								</div>

							</div>

							<div class="sec_sep"></div>

							<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 stream_panel" v-if="showRecommendationsTab">

								<div class="row">
									<div class="col-12">

										<div class="sec_hd row">
											<h3 class="col-12 ace_sec_hd" :aria-label="streamRecommendationsLabel">{{streamRecommendationsLabel}}</h3>
										</div>

										<div v-if="isAlumniStreamRecommendationsEnabled" class="row">
											<div class="col-12 stream_type_sec" v-if="alumniStreamRecommendations && alumniStreamRecommendations.length > 0">

												<div class="row">
													<div class="col-12 sub_hd ace_sec_txt" :aria-label="alumniStreamRecommendationsLabel">{{alumniStreamRecommendationsLabel}}</div>
												</div>

												<div class="row">
													<div class="col-12 pg_sec2">
														<div class="content_row">
															<template v-for="stream in alumniStreamRecommendationsToShow">
																<div class="content_block_inner">
																	<div class="float-left mr-5 pointer">
																		<span v-if="isCareerSkillProgressEnabled && isStudentLogin" class="title" :id="'alumniStreamSkillProgressPopup_' + stream.uuid" @click="calculateStreamSkillProgressClicked(stream.streamId, stream.streamTitle, $event)" style="font-size: 13px; color: #74aac2;">Skills</span>
																	</div>
																	<div class="thumbnail" @click="goToStreamTime(stream)" role="button" :aria-label="stream.streamTitle" :title="stream.streamTitle" v-bind:style="{background:setThumbnailBgColor(stream.uuid)}">
																		<div class="txt_bx" v-html="setTitleInitials(stream.streamTitle)"></div>
																	</div>
																	<div class="title_container" :style="{width: (isCareerSkillProgressEnabled && isStudentLogin) ? 'calc(100% - 135px) !important' : ''}">
																		<span class="title ace_sec_txt" @click.stop.prevent="goToStreamPage(stream)" :aria-label="stream.streamTitle" :title="stream.streamTitle">
																			{{stream.streamTitle}}
																		</span>
																	</div>
																</div>
															</template>
														</div>
													</div>
												</div>

											</div>
										</div>

										<div v-if="isAdvisorStreamRecommendationsEnabled" class="row">
											<div class="col-12 stream_type_sec" v-if="advisorStreamRecommendations && advisorStreamRecommendations.length > 0">

												<div class="row">
													<div class="col-12 sub_hd ace_sec_hd" :aria-label="advisorStreamRecommendationsLabel">{{advisorStreamRecommendationsLabel}}</div>
												</div>

												<div class="row">
													<div class="col-12 pg_sec2">
														<div class="content_row">
															<template v-for="stream in advisorStreamRecommendationsToShow">
																<div class="content_block_inner">
																	<div class="float-left mr-5 pointer">
																		<span v-if="isCareerSkillProgressEnabled && isStudentLogin" class="title" :id="'advisorStreamCreditProgressPopup_' + stream.uuid" @click="calculateStreamSkillProgressClicked(stream.uuid, stream.title, $event)" style="font-size: 13px; color: #74aac2;">Skills</span>
																	</div>
																	<div class="thumbnail" @click="goToStreamTime(stream)" role="button" :aria-label="stream.title" :title="stream.title" v-bind:style="{background:setThumbnailBgColor(stream.uuid)}">
																		<div class="txt_bx" v-html="setTitleInitials(stream.title)"></div>
																	</div>
																	<div class="title_container" :style="{width: (isCareerSkillProgressEnabled && isStudentLogin) ? 'calc(100% - 135px) !important' : ''}">
																		<span class="title ace_sec_txt" @click.stop.prevent="goToStreamPage(stream)" :aria-label="stream.title" :title="stream.title">
																			{{stream.title}}
																		</span>
																	</div>
																</div>
															</template>
														</div>
													</div>
												</div>

											</div>
										</div>

										<div v-if="isAlumniStreamRecommendationsEnabled || isAdvisorStreamRecommendationsEnabled" class="row">
											<div class="col-12 no_data empty_pattern ace_sec_txt" v-if="(alumniStreamRecommendations && alumniStreamRecommendations.length == 0) && (advisorStreamRecommendations && advisorStreamRecommendations.length == 0)">
												No pathway available
											</div>
										</div>

									</div>

								</div>
							</div>

						</div>
					</div>--> <!-- .content_rgt_panel -->

        </div> <!-- .pg_content // end EMSI data-->

				<div v-else-if="!isEMSIFeatureEnabled && !isBGTFeatureEnabled && !isLightcastFeatureEnabled" class="row pg_content">

					<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">

              <!-- Job Posting -->
              <div v-if="careerOneStopInfo && careerOneStopInfo.medianEarning" class="row pg_sec" :class="selectedMetroArea ? 'city_data_selected' : ''">
                <div class="col-12 hd ace_sec_hd" aria-label="Career Outlook">
                  <h2>Career Outlook</h2>
                  <span class="hd_bdr"></span>
                </div>


								<div class="row content_sec jobs_outlook national_data ml-4" style="background: rgb(245, 245, 245); padding: 25px 25px;">

									<div class="card col-4 salary">
										<div class="card-body">
											<div class="crd_data">
												<div class="crd_data_inner">
													<div class="ic_container">
														<div class="ic ic8-salary"></div>
													</div>
													<div class="values">
														<div class="main_val_1" :aria-label="'Median Income $ ' + addCommaInNumber(career.medianIncomePerYear)">
															<template v-if="formattedCareer && formattedCareer.medianIncomePerYear">
																<div class="val_1_txt salary">
																	$<span v-html="addCommaInNumber(formattedCareer.medianIncomePerYear)"></span>
																</div>
															</template>
															<template v-else-if="careerOneStopInfo && careerOneStopInfo.medianEarning">
																<div class="val_1_txt salary">
																	$<span v-html="addCommaInNumber(careerOneStopInfo.medianEarning)"></span>
																</div>
															</template>
														</div>
                            <div class="add_val" v-if="formattedCareer.annualEarning90thPercentile">
                              hi - $<span v-html="addCommaInNumber(formattedCareer.annualEarning90thPercentile)"></span>
                            </div>
                            <div class="add_val" v-if="formattedCareer.annualEarning10thPercentile">
                              low - $<span v-html="addCommaInNumber(formattedCareer.annualEarning10thPercentile)"></span>
                            </div>
													</div>
											 </div>
											</div>
											<div class="crd_title">
												<span class="title_txt">
													<span class="ic">
														<span class="ic8-salary"></span>
													</span>
													<span class="txt">
														<span class="txt_1">Median </span>
														<span class="txt_2">Income</span>
													</span>
												</span>
											</div>
										</div>
									</div>

									<div class="card col-4">
										<div class="card-body">
											<template v-if="!selectedMetroArea">
												<div class="crd_data" :aria-label="'Estimated Job Growth in 2023-2033 ' + career.growth + '%'">
													<div class="row">
														<div class="col-xl-7 col-lg-6 col-md-12 col-sm-12 chart_container">
															<div class="row legend">
																<div class="col-6 lg_lft">0%</div>
																<div class="col-6 lg_rgt">15%</div>
															</div>
															<div class="gph_chart gph_pie_chart">
																<template v-if="formattedCareer && formattedCareer.growth">
																	<doughnut-chart :chart-data="growthPieData" id="non-bgt-gauge" :options="growthPieOptions" @afterComplete="callDrawNeedle('non-bgt-gauge', formattedCareer.growth)" :key="growthComponentKey"></doughnut-chart>
																</template>
																<template v-else-if="careerOneStopInfo && careerOneStopInfo.growth">
																	<doughnut-chart :chart-data="growthPieData" id="non-bgt-cos-gauge" :options="growthPieOptions" @afterComplete="callDrawNeedle('non-bgt-cos-gauge', careerOneStopInfo.growth)" :key="growthComponentKey"></doughnut-chart>
																</template>
															</div>
														</div>
														<div class="col-xl-5 col-lg-6 col-md-12 col-sm-12 main_val_1 gph_val" style="margin-top: -4px;">
															<div v-if="formattedCareer && formattedCareer.growth" class="gph_val pie_chart_val">
				                        <span class="val_1_txt" v-html="(Math.round(formattedCareer.growth * 100) / 100).toFixed(1)"></span><span>%</span>
				                      </div>
				                      <div v-else-if="careerOneStopInfo && careerOneStopInfo.growth" class="gph_val pie_chart_val">
				                        <span class="val_1_txt" v-html="(Math.round(careerOneStopInfo.growth * 100) / 100).toFixed(1)"></span><span>%</span>
				                      </div>
														</div>
													</div>
												</div>
												<div class="crd_title">
													<span class="title_txt">
														<span class="txt_1">Estimated Job Growth </span>
														<span class="txt_2">2023-2033</span>
												 </span>
												</div>
											</template>
										</div>
									</div>

									<div class="card col-4 postings">
										<div class="card-body">
											<div class="crd_data">
												<div class="crd_data_inner" v-if="formattedCareer && formattedCareer.openings" :aria-label="'job postings in the last 12 months ' + addCommaInNumber(formattedCareer.openings)">
													<div class="ic_container">
														<div class="ic ic8-job2"></div>
													</div>
													<div class="values">
														<div class="main_val_1">
															<template v-if="formattedCareer && formattedCareer.openings">
				                        <div class="val_1_txt">
				                          <span v-html="formatNumericVal(formattedCareer.openings)"></span>
				                        </div>
					                    </template>
															<template v-else-if="careerOneStopInfo && careerOneStopInfo.openings">
				                        <div class="val_1_txt">
				                          <span v-html="formatNumericVal(careerOneStopInfo.openings)"></span>
				                        </div>
					                    </template>
														</div>
													</div>
											 </div>
											</div>
											<div class="crd_title">
												<span class="title_txt">
													<span class="ic">
														<span class="ic8-job2"></span>
													</span>
													<span class="txt">
														<span class="txt_1">Job Postings </span>
														<span class="txt_2">2023 - 2033</span>
													</span>
												</span>
											</div>
										</div>
									</div>

								</div>

              </div>

						<!--
						==================================================================================
						==================================================================================
						T0 Do -- Neeraj [31 Jan 2020]
						Hide video section as whole page is display, work on this after release
						==================================================================================
						==================================================================================
						-->


						<!-- Top Skills -->
						<div class="row pg_sec" v-if="formattedCareer.topSkillsLabel && formattedCareer.topSkillsLabel.length > 0">
              <div class="col-12 hd ace_sec_hd" aria-label="Top In-Demand Skills within Job Postings">
                <h2>Top In-Demand Skills within Job Postings</h2>
                <span class="hd_bdr"></span>
              </div>

              <div class="col-12 sec_content">
                <div class="row">
									<!--
									ToDo - Neeraj [07 Feb 2020]: Limit the result size upto 10 by chart.scss file for now,
									need to make it configurable under admin settings to update the size of chart
									-->
									<div class="col-12 gph_sec ace_sec" aria-label="Skills">
										<div class="time_chart_container chart_top_skills" :class="'chart_blocks_' + formattedCareer.topSkillsLabel.length">
											<div class="row">
												<template v-for="(skills, index) in formattedCareer.topSkillsLabel">
													<div class="col-12 bar_block ace_sec"
													:class="'bar_block_' + index">

													<b-popover :target="'popoverTarget_skills_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="skillsToolTip">
														<div class="tooltip_row">
															<!--
															<div class="label">Top Skill</div>
															-->
															<div class="val">{{ skills }}</div>
														</div>
													</b-popover>

													<div id="skillsToolTip" class="chart_tooltip_popover"></div>

													<div class="bar_block_inner" :id="'popoverTarget_skills_' + index">
														<div class="row">
															<div class="col-12 bar_title">{{ skills }} </div>
														</div>
													</div>

													</div>
												</template>
											</div>
										</div>
									</div>

                </div>
              </div>
            </div>
						<!-- Top Skills -->

						<!--
            <div class="row pg_sec" v-if="formattedCareer.abilitiesLabel && formattedCareer.abilitiesLabel.length > 0">
              <div class="col-12 hd ace_sec_hd" aria-label="Abilities">
                <h2>Abilities</h2>
                <span class="hd_bdr"></span>
              </div>

              <div class="col-12 sec_content">
                <div class="row">
                  <div class="col-12 tbl_sec">
                    <div class="content-row ace_sec_txt" :aria-label="formattedCareer.abilitiesLabel">{{formattedCareer.abilitiesLabel}}</div>
                  </div>
                </div>
              </div>
            </div>
						-->
						<!-- Abilities -->
						<div class="row pg_sec" v-if="formattedCareer.abilitiesLabel && formattedCareer.abilitiesLabel.length > 0">
              <div class="col-12 hd ace_sec_hd" aria-label="Abilities">
                <h2>Abilities</h2>
                <span class="hd_bdr"></span>
              </div>

              <div class="col-12 sec_content">
                <div class="row">
									<!--
									ToDo - Neeraj [07 Feb 2020]: Limit the result size upto 10 by chart.scss file for now,
									need to make it configurable under admin settings to update the size of chart
									-->
									<div class="col-12 gph_sec ace_sec" aria-label="Abilities">
										<div class="time_chart_container chart_abilities" :class="'chart_blocks_' + formattedCareer.abilitiesLabel.length">
											<div class="row">
												<template v-for="(abilities, index) in formattedCareer.abilitiesLabel">
													<div class="col-12 bar_block ace_sec"
													:class="'bar_block_' + index">

													<b-popover :target="'popoverTarget_abilities_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="abilitiesToolTip">
														<div class="tooltip_row">
															<!--
															<div class="label">Ability</div>
															-->
															<div class="val">{{ abilities }}</div>
														</div>
													</b-popover>

													<div id="abilitiesToolTip" class="chart_tooltip_popover"></div>

													<div class="bar_block_inner" :id="'popoverTarget_abilities_' + index">
														<div class="row">
															<div class="col-12 bar_title">{{ abilities }} </div>
														</div>
													</div>

													</div>
												</template>
											</div>
										</div>
									</div>

                </div>
              </div>
            </div>
						<!-- Abilities -->

						<!--
            <div class="row pg_sec" v-if="formattedCareer.knowledgeLabel && formattedCareer.knowledgeLabel.length > 0">
              <div class="col-12 hd ace_sec_hd" aria-label="Knowledge">
                <h2>Knowledge</h2>
                <span class="hd_bdr"></span>
              </div>

              <div class="col-12 sec_content">
                <div class="row">
                  <div class="col-12 tbl_sec">
                    <div class="content-row ace_sec_txt" :aria-label="formattedCareer.knowledgeLabel">{{formattedCareer.knowledgeLabel}}</div>
                  </div>
                </div>
              </div>
            </div>
						-->
						<!-- Knowledge -->
						<div class="row pg_sec" v-if="formattedCareer.knowledgeLabel && formattedCareer.knowledgeLabel.length > 0">
              <div class="col-12 hd ace_sec_hd" aria-label="Knowledge">
                <h2>Knowledge</h2>
                <span class="hd_bdr"></span>
              </div>

              <div class="col-12 sec_content">
                <div class="row">

									<div class="col-12 gph_sec ace_sec" aria-label="Knowledge">
										<div class="time_chart_container chart_top_skills" :class="'chart_blocks_' + formattedCareer.knowledgeLabel.length">
											<div class="row">
												<template v-for="(knowledges, index) in formattedCareer.knowledgeLabel">
													<div class="col-12 bar_block ace_sec"
													:class="'bar_block_' + index">

													<b-popover :target="'popoverTarget_knowledges_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="knowledgeToolTip">
														<div class="tooltip_row">
															<!--
															<div class="label">Knowledge</div>
															-->
															<div class="val">{{ knowledges }}</div>
														</div>
													</b-popover>

													<div id="knowledgeToolTip" class="chart_tooltip_popover"></div>

													<div class="bar_block_inner" :id="'popoverTarget_knowledges_' + index">
														<div class="row">
															<div class="col-12 bar_title">{{ knowledges }} </div>
														</div>
													</div>

													</div>
												</template>
											</div>
										</div>
									</div>

                </div>
              </div>
            </div>
						<!-- Knowledge -->


						<!--
						==================================================================================
						==================================================================================
						T0 Do -- Neeraj [31 Jan 2020]
						Hide Departments and Industries section as we need to show data in graphical form,
						work on this after release
						==================================================================================
						==================================================================================

            <div class="row pg_sec" v-if="formattedCareer.departmentsLabel && formattedCareer.departmentsLabel.length > 0">
              <div class="col-12 hd ace_sec_hd" aria-label="Departments">
                <h2>Departments</h2>
                <span class="hd_bdr"></span>
              </div>

              <div class="col-12 sec_content">
                <div class="row">
                  <div class="col-12 tbl_sec">
                    <div class="content-row ace_sec_txt" :aria-label="formattedCareer.departmentsLabel">{{formattedCareer.departmentsLabel}}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row pg_sec" v-if="formattedCareer.industriesLabel && formattedCareer.industriesLabel.length > 0">
              <div class="col-12 hd ace_sec_hd" aria-label="Industries">
                <h2>Industries</h2>
                <span class="hd_bdr"></span>
              </div>

              <div class="col-12 sec_content">
                <div class="row">
                  <div class="col-12 tbl_sec">
                    <div class="content-row ace_sec_txt" :aria-label="formattedCareer.industriesLabel"> {{formattedCareer.industriesLabel}} </div>
                  </div>
                </div>
              </div>
            </div>

					-->

						<!-- Annual Wage Percentiles Chart -->
						<div class="row pg_sec" v-if="careerOneStopInfo && careerOneStopInfo.annualWagePercentiles">
              <div class="col-12 hd ace_sec_hd" aria-label="Annual Wage Percentiles">
                <h2>Annual Wage Percentiles</h2>
                <span class="hd_bdr"></span>
              </div>

							<div class="col-12 gph_sec ace_sec" aria-label="Annual Wage Percentiles Chart">
								<div class="bar_chart_container bar_label_inside chart_annual_wage_percentiles">
									<template v-for="(wage, index) in careerOneStopInfo.annualWagePercentiles">
										<div class="row bar_row ace_sec" :aria-label="'Annual Wage Percentiles for ' + wage.key + ' is ' + wage.value">
											<div class="col-12">

												<div id="annualWagePercentilesToolTip" class="chart_tooltip_popover"></div>
												<b-popover :target="'popoverAnnualWage_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="annualWagePercentilesToolTip">
													<div class="tooltip_row">

														<div class="label">Wage Percentiles</div>

														<div class="val">{{ wage.key }}</div>
													</div>
													<div class="tooltip_row">
														<div class="val"><span v-html="'$' + addCommaInNumber(wage.value)"></span></div>
													</div>
												</b-popover>

												<div class="bar_container" :id="'popoverAnnualWage_' + index">
													<div class="bar_label">{{ wage.key }} </div>
													<div class="bar_val"><span v-html="'$' + addCommaInNumber(wage.value)"></span></div>
													<div class="bar" v-bind:style="{width:getNumberFromValue(wage.key) + '%'}"></div>
												</div>

											</div>
										</div>
									</template>
								</div>
							</div>

						</div>
						<!-- Annual Wage Percentiles Chart -->


            <div class="row pg_sec" v-if="educationItems && educationItems.length > 0">
              <div class="col-12 hd ace_sec_hd" aria-label="National Educational Attainment">
                <h2>National Educational Attainment</h2>
                <span class="hd_bdr"></span>
              </div>

							<div class="col-12 gph_sec ace_sec" aria-label="National Educational Attainment Chart">
								<div class="bar_chart_container bar_label_inside chart_national_educational_attainment">
									<template v-for="(educationItems, index) in educationItems">
										<div class="row bar_row ace_sec" :aria-label="'National Educational Attainment for ' + educationItems.Education_Level + ' is ' + educationItems.Percent + '%.'">
											<div class="col-12">

												<div id="educationalAgeToolTip" class="chart_tooltip_popover"></div>
												<b-popover :target="'popoverEducation_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="educationalAgeToolTip">
													<div class="tooltip_row">
														<div class="label">Education Level</div>
														<div class="val">{{ educationItems.Education_Level }}</div>
													</div>
													<div class="tooltip_row">
														<div class="val">{{ educationItems.Percent }}%</div>
													</div>
												</b-popover>

												<div class="col-12 bar_container" :id="'popoverEducation_' + index">
													<div class="bar_label">{{ educationItems.Education_Level }} </div>
													<div class="bar_val"><span v-html="formatDecimalValue(educationItems.Percent) + '%'"></span></div>
													<div class="bar" v-bind:style="{width:educationItems.Percent + '%'}"></div>
												</div>

											</div>
										</div>
									</template>
								</div>
							</div>

							<!--
              <div class="col-12 sec_content">
                <div class="row">
                  <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 gph_sec ace_sec" aria-label="Education graph section">
                    <vc-donut v-if="educationDonutChartItems && educationDonutChartItems.length > 0" has-legend :size="educationDonutChartSize" :unit="px" :sections="educationDonutChartItems"></vc-donut>
                  </div>
                  <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 tbl_sec">
                    <div v-if="educationItems && educationItems.length > 0">
                      <div class="table-container ace_sec" aria-label="Education Field items">
                        <b-table :items="educationItems" :fields="educationFields"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
							-->

            </div>
            <!--
            <div class="row pg_sec" v-if="formattedCareer.majors && formattedCareer.majors.length > 0">
              <div class="col-12 hd ace_sec_hd" aria-label="Programs for this Occupation">
                <h2>Programs for this Occupation</h2>
                <span class="hd_bdr"></span>
              </div>

              <div class="col-12 sec_content">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 tbl_sec">
                    <template v-for="(major, cipCodeIndex) in formattedCareer.majors">
                      <div class="programs" :aria-label="'programs ' + major" tabindex="0">
                        <a href="#" @click.stop.prevent="goToProgramGuideDetail(major, cipCodeIndex)">{{major}}</a>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          -->

						<!--
            <div class="row pg_sec" v-if="formattedCareer.topSkillsLabel && formattedCareer.topSkillsLabel.length > 0">
              <div class="col-12 hd ace_sec_hd" aria-label="Top Skills">
                <h2>Top Skills</h2>
                <span class="hd_bdr"></span>
              </div>

              <div class="col-12 sec_content">
                <div class="row">
                  <div class="col-12 tbl_sec">
                    <div class="content-row ace_sec_txt" :aria-label="formattedCareer.topSkillsLabel">{{formattedCareer.topSkillsLabel}}</div>
                  </div>
                </div>
              </div>
            </div>
						-->


          </div> <!-- .content_mid_panel -->

          <!--<div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 content_rgt_panel">
            <div class="row">

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 thumbnail_container">

								<template v-if="careerOneStopInfo && careerOneStopInfo.videoURL">
									<b-modal class="video_popup" ref="videoModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc centered size="lg">
										<div class="btn_container">
											<button class="btn_close" @click="closeVideoPopup()" title="close">
												<span class="ic-close"></span>
											</button>
										</div>
										<template v-if="isVideoModalEnable">
											<video width="100%" controls autoplay>
											  <source :src="careerOneStopInfo.videoURL" type="video/mp4">
											</video>
					          </template>
									</b-modal>

									<div class="play_video" :class="formattedCareer.thumbnailURI ? '' : 'default_thumb_layer'">
										<span class="ic ic8-play2" @click="showVideoPopup()"></span>
									</div>
								</template>

								<img
									:src="formattedCareer.thumbnailURI"
									v-if="formattedCareer.thumbnailURI"
									tabindex="0"
									onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
                <div v-else class="thumbnail_default ico-career"></div>
              </div>

              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 other_info">

								<div class="sec_hd row">
									<div class="col-10">
										<h3 class="ace_sec_hd">US Data</h3>
									</div>

									<div class="col-2 data_souce_info" style="margin-right: 0px; margin-top: -4px;">
										<div id="dataSouceInfo" style="float: right;">
											<span class="ic ic8-info5"></span>
										</div>
										<b-popover target="dataSouceInfo" container="dataSouceInfoPopup" triggers="hover" style="margin-top: 20px;">
											<div class="popup_content">
												{{careerDataSource}}
											</div>
										</b-popover>
										<div id="dataSouceInfoPopup"></div>
									</div>
								</div>

                <div v-if="showMedianIncome" class="list_info_row ace_sec_txt" :aria-label="'median income ' + currencyLabel + career.medianIncomePerYear">
                  <div class="info_title lft_dir">{{medianIncomeLabel}}</div>
                  <div class="info_val" v-if="career.medianIncomePerYear">
                    {{currencyLabel}} <span v-html="addCommaInNumber(career.medianIncomePerYear)"></span>
                  </div>

                  <div class="info_no_val" v-else>N/A</div>
                  <div class="info_title rgt_dir">{{medianIncomeLabel}}</div>
                </div>

                <div v-if="showJobPostings" class="list_info_row ace_sec_txt" :aria-label="'job postings ' + career.openings">
                  <div class="info_title lft_dir">{{jobPostingsLabel}}</div>
                  <div class="info_val" v-if="career.openings">
                    <span v-html="addCommaInNumber(career.openings)"></span>
                  </div>
                  <div class="info_no_val" v-else>N/A</div>
                  <div class="info_title rgt_dir">{{jobPostingsLabel}}</div>
                </div>

                <div v-if="showGrowthRate" class="list_info_row ace_sec_txt" :aria-label="'growth rate ' + career.growth">
                	<div class="info_title lft_dir">{{growthRateLabel}}<span class="exclamation-circle" v-popover:tooltip="careerDataSource"><span class="ico-error"></span></span></div>
                  	<div class="info_val" v-if="career.growth" :title="career.growth">{{career.growth}}</div>
                  	<div class="info_no_val" v-else>N/A</div>
                  	<div class="info_title rgt_dir">{{growthRateLabel}}<span class="exclamation-circle" v-popover:tooltip="careerDataSource"><span class="ico-error"></span></span></div>
                </div>

              </div>

							<template v-if="isEMSIFeatureEnabled || isBGTFeatureEnabled">
								<div v-if="careerOneStopInfo.outlook" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 content_sec">
									<div class="row">

										<div class="col-12">
											<div class="sec_sep"></div>
										</div>

										<div class="col-12 sec_hd ace_sec_hd" aria-label="Outlook">
				              <h3>Outlook</h3>
				            </div>

				            <div class="col-12">
											<div class="content_sec_inner" id="popoverOutlook">

											   <div id="outlooktTooltip" class="chart_tooltip_popover"></div>

											      <b-popover target="popoverOutlook" v-if="careerOneStopInfo.outlook"  triggers="hover" placement="left" class="chart_tooltip_popover" container="outlooktTooltip">
                                                       <div class="tooltip_row">
													        <div class="label hd_title">Outlook for this career is</div>
                                                           <div class="val">{{careerOneStopInfo.outlook}}</div>
                                                       </div>
                                                   </b-popover>

												<template v-if="careerOneStopInfo.outlook === 'Bright'">
													<div class="img_container">
														<img src="../../../assets/module/img/explore/career/outlookBright.svg" />
													</div>
												</template>
												<template v-else-if="careerOneStopInfo.outlook === 'Average'">
													<div class="img_container">
														<img src="../../../assets/module/img/explore/career/outlookAverage.svg" />
												</div>
												</template>
												<template v-else-if="careerOneStopInfo.outlook === 'Below Average'" >
													<div class="img_container">
														<img src="../../../assets/module/img/explore/career/outlookBelowAverage.svg" />
													</div>
												</template>
												<template v-else>
													<span>{{careerOneStopInfo.outlook}}</span>
												</template>
											</div>
				                   </div>

									</div>
			          </div>

			          <div v-if="careerOneStopInfo.outlookCategory" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 content_sec">
									<div class="row">

										<div class="col-12">
			            		<div class="sec_sep"></div>
			            	</div>

										<div class="col-12 sec_hd ace_sec_hd" aria-label="Outlook Category">
				              <h3>Outlook Category</h3>
				            </div>

				            <div class="col-12">
				              <span>{{careerOneStopInfo.outlookCategory}}</span>
				            </div>

				          </div>
								</div>
							</template>

							<template v-else-if="!isEMSIFeatureEnabled && !isBGTFeatureEnabled">
								<div v-if="careerOneStopInfo.outlook" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 content_sec">
									<div class="row">

										<div class="col-12">
			            		<div class="sec_sep"></div>
			            	</div>

			              <div class="col-12 sec_hd ace_sec_hd" aria-label="Outlook">
			                <h3>Outlook</h3>
			              </div>

			              <div class="col-12">
											<div class="content_sec_inner" id="popoverOutlook">

											   <div id="outlooktTooltip" class="chart_tooltip_popover"></div>
											      <b-popover target="popoverOutlook" v-if="careerOneStopInfo.outlook" triggers="hover" placement="left" class="chart_tooltip_popover" container="outlooktTooltip">
                                                       <div class="tooltip_row">
													      <div class="label hd_title">Outlook for this career is</div>
                                                           <div class="val">{{careerOneStopInfo.outlook}}</div>
                                                       </div>
                                                   </b-popover>

												<template v-if="careerOneStopInfo.outlook === 'Bright'">
													<div class="img_container">
														<img src="../../../assets/module/img/explore/career/outlookBright.svg" />
													</div>
												</template>
												<template v-else-if="careerOneStopInfo.outlook === 'Average'">
													<div class="img_container">
														<img src="../../../assets/module/img/explore/career/outlookAverage.svg" />
													</div>
												</template>
												<template v-else-if="careerOneStopInfo.outlook === 'Below Average'">
													<div class="img_container">
														<img src="../../../assets/module/img/explore/career/outlookBelowAverage.svg" />
													</div>
												</template>
												<template v-else>
													<span>{{careerOneStopInfo.outlook}}</span>
												</template>

											</div>
			              </div>

									</div>
		            </div>

								<div v-if="careerOneStopInfo.outlookCategory" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 content_sec">
									<div class="row">

										<div class="col-12">
			            		<div class="sec_sep"></div>
			            	</div>

										<div class="col-12 sec_hd ace_sec_hd" aria-label="Outlook Category">
			                <h3>Outlook Category</h3>
			              </div>

			              <div class="col-12">
			                <span>{{careerOneStopInfo.outlookCategory}}</span>
			              </div>
			            </div>
								</div>
							</template>

							<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 content_sec" v-if="showRecommendationsTab" aria-label="streams">
								<div class="row">

									<div class="col-12">
										<div class="sec_sep"></div>
									</div>

                	<div class="col-12">

										<div class="sec_hd row">
    									<h3 class="col-12 ace_sec_hd" :aria-label="streamRecommendationsLabel">{{streamRecommendationsLabel}}</h3>
    								</div>

                  	<div v-if="isAlumniStreamRecommendationsEnabled" class="row">
                  		<div class="col-12 stream_type_sec"v-if="alumniStreamRecommendations && alumniStreamRecommendations.length > 0">

		                    <div class="row">
		                    	<div class="col-12 sub_hd ace_sec_hd" :aria-label="alumniStreamRecommendationsLabel">{{alumniStreamRecommendationsLabel}}</div>
		                    </div>

		                    <div class="row">
			                    <div class="col-12 pg_sec2">
			                    	<div class="content_row">
															<template v-for="stream in alumniStreamRecommendationsToShow">
																<div class="content_block_inner">
																	<div class="float-left mr-5 pointer">
																		<span v-if="isCareerSkillProgressEnabled && isStudentLogin" class="title" :id="'alumniStreamSkillProgressPopup_' + stream.uuid" @click="calculateStreamSkillProgressClicked(stream.streamId, stream.streamTitle, $event)" style="font-size: 13px; color: #74aac2;">Skills</span>
																	</div>
																	<div class="thumbnail" @click="goToStreamTime(stream)" role="button" :aria-label="stream.streamTitle" :title="stream.streamTitle" v-bind:style="{background:setThumbnailBgColor(stream.uuid)}">
																		<div class="txt_bx" v-html="setTitleInitials(stream.streamTitle)"></div>
																	</div>
																	<div class="title_container" :style="{width: (isCareerSkillProgressEnabled && isStudentLogin) ? 'calc(100% - 135px) !important' : ''}">
																		<span class="title ace_sec_txt" @click.stop.prevent="goToStreamPage(stream)" :aria-label="stream.streamTitle" :title="stream.streamTitle">
																			{{stream.streamTitle}}
																		</span>
																	</div>
																</div>
															</template>
														</div>
													</div>
												</div>

											</div>
										</div>

										<div v-if="isAdvisorStreamRecommendationsEnabled" class="row stream_type_sec">
											<div class="col-12" v-if="advisorStreamRecommendations && advisorStreamRecommendations.length > 0">

												<div class="row">
													<div class="col-12 sub_hd ace_sec_hd" :aria-label="advisorStreamRecommendationsLabel">{{advisorStreamRecommendationsLabel}}</div>
												</div>

												<div class="row">
													<div class="col-12 pg_sec2">
														<div class="content_row">
															<template v-for="stream in advisorStreamRecommendationsToShow">
																<div class="content_block_inner">
																	<div class="float-left mr-5 pointer">
																		<span v-if="isCareerSkillProgressEnabled && isStudentLogin" class="title" :id="'advisorStreamCreditProgressPopup_' + stream.uuid" @click="calculateStreamSkillProgressClicked(stream.uuid, stream.title, $event)" style="font-size: 13px; color: #74aac2;">Skills</span>
																	</div>
																	<div class="thumbnail" @click="goToStreamTime(stream)" role="button" :aria-label="stream.title" :title="stream.title" v-bind:style="{background:setThumbnailBgColor(stream.uuid)}">
																		<div class="txt_bx" v-html="setTitleInitials(stream.title)"></div>
																	</div>
																	<div class="title_container" :style="{width: (isCareerSkillProgressEnabled && isStudentLogin) ? 'calc(100% - 135px) !important' : ''}">
																		<span class="title ace_sec_txt" @click.stop.prevent="goToStreamPage(stream)" :aria-label="stream.title" :title="stream.title">
																			{{stream.title}}
																		</span>
																	</div>
																</div>
															</template>
														</div>
													</div>
												</div>

											</div>
										</div>

										<div v-if="isAlumniStreamRecommendationsEnabled || isAdvisorStreamRecommendationsEnabled" class="row">
											<div class="col-12 no_data empty_pattern ace_sec_txt" v-if="(alumniStreamRecommendations && alumniStreamRecommendations.length == 0) && (advisorStreamRecommendations && advisorStreamRecommendations.length == 0)">
												No pathway available
											</div>
										</div>

									</div>
								</div>

							</div>

						</div>
					</div>--> <!-- .content_rgt_panel -->

				</div> <!-- .pg_content end CAREER ONE DATA-->

        <template v-if="showStreamSkillProgressPopup">
            <career-stream-skill-progress
                :title="selectedStreamTitle"
                :stream-id="selectedStreamUuid"
                :career-id="career.uuid"
                :skill-progress-target-id="streamSkillProgressTargetId">
            </career-stream-skill-progress>
        </template>

        <template v-if="showSkillProgressPopup">
          <explore-career-skill-progress
            :title="selectedCareer.name"
            :stream-id="planningStream.uuid"
            :career-id="selectedCareer.uuid"
            :skill-progress-target-id="skillProgressTargetId">
          </explore-career-skill-progress>
        </template>

		</div> <!-- .page_content_container -->


		<div class="loading-spinner">
			<b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
				<div class="text-center" style="color: #FFF">
					<i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
				</div>
			</b-modal>
		</div>

    <div class="modal_popup_container">
      <b-modal id="userVerificationPopup" ref="newFormModal" centered hide-footer class="usr_verification_popup" no-close-on-backdrop>
        <div slot="modal-header" class="header-section">
          <div class="head_txt">
            Create Your Account To Explore More
          </div>
          <div class="btn_container">
            <button class="btn_close" aria-label="close" @click="closeModalBox">
            <span class="ic-close"></span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-1 lft_col"></div>
          <div class="col-5 content_col">
						<div class="pr-5">
            	<p>Your institution has made the Pragya Explore app available to you for free.</p>
            	<p>Your Data is completely secure. Read our <a v-if="institution.privacyPolicyLink" :href="institution.privacyPolicyLink" target="_blank">Privacy Policy</a> <a v-if="!institution.privacyPolicyLink" href="https://site.pragyasystems.com/privacy-policy/" target="_blank">Privacy Policy</a></p>
              <p v-if="isShowPhoneOnCreateAccountModalEnabled">{{showPhoneOnCreateAccountModalLabel}}</p>
						</div>
          </div>
          <div class="col-5 content_col">
            <p v-if="newProspectError" class="text-danger">{{newProspectError}}</p>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="firstName">First Name <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="text" v-model.trim="newForm.firstName" placeholder="First Name">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="lastName">Last Name <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="text" v-model.trim="newForm.lastName" placeholder="Last Name">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="lastName">Password <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="password" v-model.trim="newForm.password" placeholder="Password">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="lastName">Confirm Password <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="password" v-model.trim="repassword" placeholder="Confirm Password">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section" v-if="isShowPhoneOnCreateAccountModalEnabled">
              <div class="col-12">
                <div class="fld-label" id="lastName">Phone Number <sup v-if="isPhoneRequiredOnCreateAccountModal">*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="text" v-model.trim="newForm.primaryPhoneNumber" placeholder="Phone Number">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="lastName">By clicking on Create Account you are accepting our <a v-if="institution.privacyPolicyLink" :href="institution.privacyPolicyLink" target="_blank">Privacy Policy</a> <a v-if="!institution.privacyPolicyLink" href="https://site.pragyasystems.com/privacy-policy/" target="_blank">Privacy Policy</a> & <a href="https://site.pragyasystems.com/terms-of-use/" target="_blank">Terms of Use</a></div>
              </div>
            </div>
            <div class="row popup_btn_container">
              <div class="col-6 pragya_login_lnk">
              </div>
              <div class="col-6 popup_btn">
                <b-button size="lg" @click="registerProspectiveStudent()"aria-label="verify">Create Account</b-button>
              </div>
            </div>
          </div>
          <div class="col-1 rgt_col"></div>
        </div>
      </b-modal>
    </div>

	</div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import _ from 'lodash'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import CareerTitle from './CareerTitle'
  import CareerNavigation from './CareerNavigation'
  import DoughnutChart from './DoughnutChart'
  import LineChart from './LineChart'
  import CareerStreamSkillProgress from './CareerStreamSkillProgress'
  import ExploreCareerSkillProgress from '../../explore/components/ExploreCareerSkillProgress'

  export default {
    name: 'career-detail',
    props: ['code', 'cipCode', 'programGuideCode', 'type', 'returnTo', 'showBackToResultButton', 'loadDataFromServer'],
    components: {
    	CareerTitle,
      CareerNavigation,
      DoughnutChart,
      CareerStreamSkillProgress,
      ExploreCareerSkillProgress,
      LineChart
    },
    data: () => {
      return {
        RECOMMENDATION_TERM_LIMIT: 3,
        DEFAULT_RETURN_TO: 'exploreCareerResults',
        EXPLORE_RESULTS: 'exploreCareerResults',
        genderFields: [' ', 'Gender', 'Percent'],
        genderItems: [],
        genderDonutChartItems: [],
        genderDonutChartSize: 100,
        occupationAgeFields: [' ', 'Age', 'Percent'],
        occupationAgeItems: [],
        occupationAgeDonutChartSize: 100,
        occupationAgeDonutChartItems: [],
        educationFields: [' ', 'Education_Level', 'Percent'],
        educationItems: [],
        experienceItems: [],
        educationDonutChartItems: [],
        experienceDonutChartItems: [],
        educationDonutChartSize: 100,
        topCompaniesFields: ['Company', 'Total', 'Unique', 'Posting_Intensity'],
        topCompaniesItems: [],
        topSkillsFields: ['Skill', 'Postings_with_Skill'],
        topSkillsItems: [],
        selectedState: null,
        selectedMetroArea: null,
        selectedCounty: null,
        disableSelectState: false,
        disableSelectMetroArea: false,
        disableSelectCounty: false,
        isLoadingSearch: false,
        isSalaryBoostSkill: false,
				isVideoModalEnable: false,
        growthPieOptions: {
          rotation: 1 * Math.PI,
          circumference: 1 * Math.PI,
          tooltips: {
            enabled: false
          }
        },
        growthComponentKey: 0,
        wagePercentileMap: {
          'annualEarning10thPercentile': '10th percentile',
          'annualEarning25thPercentile': '25th percentile',
          'annualEarning50thPercentile': '50th percentile',
          'annualEarning75thPercentile': '75th percentile',
          'annualEarning90thPercentile': '90th percentile'
        },
        selectedStreamUuid: null,
        selectedStreamTitle: null,
        streamSkillProgressTargetId: '',
        showStreamSkillProgressPopup: false,
        selectedCareer: null,
        skillProgressTargetId: '',
        showSkillProgressPopup: false,
        repassword: '',
        newForm: {
          email: '',
          firstName: '',
          lastName: '',
          password: '',
          primaryPhoneNumber: ''
        },
        newProspectError: '',
        nextPage: {},
        chartData: {
          labels: ['1 Year', '2 Year', '3 Year', '5 Year', '10 Year'],
          datasets: [
            {
              label: 'Growth',
              backgroundColor: '#d6b6fa',
              data: []
            }
          ]
        },
        chartOptions: {responsive: true, maintainAspectRatio: false},
        chartDataReady: false
      }
    },

    async mounted () {
      this.loadPermission()
      await this.loadDataForCareerDetail()
    },

    beforeRouteLeave (to, from, next) {
      // If the form is dirty and the user did not confirm leave,
      // prevent losing unsaved changes by canceling navigation
      let tempUser = localStorage.getItem('tempUser')
      if (tempUser && tempUser === 'true') {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: 'Cannot move past this page till account setup is complete'
        })
        this.showNewFormPopup()
        this.nextPage = next
      } else {
        // Navigate to next view
        next()
      }
    },

    methods: {
      ...mapActions([
        'loadCareer',
        'loadCareerResult',
        'loadCareerOneStopInfo',
        'resetCareerResult',
        'loadLibrariesForUser',
        'loadGeoIds',
        'loadPermission',
        'loadAlumniStreamRecommendations',
        'loadAdvisorStreamRecommendations',
        'loadLogDashboardActivity',
        'loadFinishAccountSetup',
        'setTemporaryUserToFalse'
      ]),
      async registerProspectiveStudent () {
        if (this.newForm.firstName.length < 1 || this.newForm.lastName.length < 1 || this.newForm.password.length < 1) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'First Name, Last Name and Password are required'
          })
        } else if (this.newForm.password !== this.repassword) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Passwords do no match'
          })
        } else if (this.isShowPhoneOnCreateAccountModalEnabled && this.isPhoneRequiredOnCreateAccountModal && this.newForm.primaryPhoneNumber.length < 1) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: 'Phone Number is required'
          })
        } else {
          this.$refs.loadingModal.show()
          await this.loadFinishAccountSetup(this.newForm)
          let bool = false
          this.setTemporaryUserToFalse()
          this.nextPage()
        }
      },
      showNewFormPopup (popupPosition) {
        this.$refs.newFormModal.show()
        $('.usr_verification_popup').removeClass('showAtTop')
        $('.usr_verification_popup').removeClass('showAtBottom')
        $('.usr_verification_popup').addClass('showAtTop')
      },
      closeModalBox () {
        this.$root.$emit('bv::hide::modal', 'userVerificationPopup')
        this.$parent.isShowTagPopup = false
        this.newForm = {
          firstName: '',
          lastName: '',
          password: '',
          primaryPhoneNumber: ''
        }
      },
      callDrawNeedle (el, value) {
        if (!document || !document.getElementById(el)) return
        let canvas = document.getElementById(el).childNodes[1]
        if (canvas) {
	        if (value && value < -10) {
	          this.drawNeedle(canvas, 50, -170 * Math.PI / 180)
	        } else if (value && value >= -10 && value < -5) {
	          this.drawNeedle(canvas, 50, -150 * Math.PI / 180)
	        } if (value && value >= -5 && value < 0) {
	          this.drawNeedle(canvas, 50, -130 * Math.PI / 180)
	        } else if (value && value >= 0 && value < 5) {
	          if (value === '0.0') {
	          	this.drawNeedle(canvas, 50, -125 * Math.PI / 180)
	          } else {
	          	this.drawNeedle(canvas, 50, -110 * Math.PI / 180)
	          }
	        } else if (value && value >= 5 && value < 10) {
	          this.drawNeedle(canvas, 50, -90 * Math.PI / 180)
	        } else if (value && value >= 10 && value < 15) {
	          this.drawNeedle(canvas, 50, -70 * Math.PI / 180)
	        } else if (value && value >= 15 && value < 20) {
	          this.drawNeedle(canvas, 50, -50 * Math.PI / 180)
	        } else if (value && value >= 20 && value < 25) {
	          this.drawNeedle(canvas, 50, -30 * Math.PI / 180)
	        } else if (value && value >= 25) {
	          this.drawNeedle(canvas, 50, -10 * Math.PI / 180)
	        }
        }
      },
      drawNeedle (canvas, radius, radianAngle) {
        var ctx = canvas.getContext('2d')
        var cw = canvas.offsetWidth
        var ch = canvas.offsetHeight
        var cx = cw / 2
        var cy = ch - (ch / 4)

        ctx.translate(cx, cy)
        ctx.rotate(radianAngle)
        ctx.beginPath()
        ctx.moveTo(0, -5)
        ctx.lineTo(radius, 0)
        ctx.lineTo(0, 5)
        ctx.fillStyle = 'rgba(100, 100, 100, 1)'
        ctx.fill()
        ctx.rotate(-radianAngle)
        ctx.translate(-cx, -cy)
        ctx.beginPath()
        ctx.arc(cx, cy, 7, 0, Math.PI * 2)
        ctx.fill()
      },
      showAll () {
        this.$root.$emit('bv::show::modal', 'careerDesc')
      },
      closeshowAll () {
        this.$root.$emit('bv::hide::modal', 'careerDesc')
      },
      showTags () {
        this.$root.$emit('bv::show::modal', 'careerTagsPopup')
      },
      closeTags () {
        this.$root.$emit('bv::hide::modal', 'careerTagsPopup')
      },
      goToEditPage () {
        this.$router.push({ name: 'editCareer', params: { uuid: this.code } })
      },
      addCommaInNumber (numValue) {
        if (!numValue) {
          return numValue
        }
        let numericValue = Math.floor(numValue)
        return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
			formatNumericVal (numValue) {
				let numericValue = Math.floor(numValue)
				return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
			},
      setSkillRowClass (skillType) {
        if (skillType === 'salaryBoostSkills') {
          this.isSalaryBoostSkill = true
        } else {
          this.isSalaryBoostSkill = false
        }
      },
      setTitleBoxWidth (entityTitle, entityId) {
        let getTitleInitials = entityTitle.match(/\b(\w)/g)
        if (getTitleInitials.length < 3) {
          $('#' + entityId).addClass('txt_bx_' + getTitleInitials.length)
        }
        return entityId
      },
      updateTitleHeight (index) {
        let titleContainerHeight = $('#entityName_' + index).height()
        if (titleContainerHeight > 30) {
          $('#entityDesc_' + index).addClass('srt_desc')
        }
      },
      getNumberFromValue (entityValue) {
        if (entityValue) {
          return entityValue.match(/\d+/)
        }
      },
      getNumberFromValueAndDivideByThousand(entityValue) {
        if (entityValue) {
          return (entityValue.match(/\d+/))/10000
        }
      },
      checkForCompanyName (companyName) {
        if (companyName === '[Unknown]') {
          return 'Others'
        }
        return companyName
      },
      formatDecimalValue (numValue) {
        if (numValue === '0') {
          return '< 0.1'
        }
        return parseFloat(numValue).toFixed(2)
      },
      goToStreamPage (stream) {
        let uuid = (stream.streamId) ? stream.streamId : stream.uuid
        return this.$router.push({ name: 'streamTime', params: { uuid: uuid } })
      },
      async loadDataForCareerDetail () {
        this.resetData()
        this.resetCareerResult()
        let career = await this.loadCareer({ code: this.code, loadDataFromServer: true })
        await this.loadCareerOneStopInfo(career.code)
        let alumniRecommendationData = this.buildAlumniStreamRecommendationData(career)
        let advisorRecommendationData = this.buildAdvisorStreamRecommendationData(career)
        this.loadAlumniStreamRecommendations({ recommendationData: alumniRecommendationData })
        this.loadAdvisorStreamRecommendations({ recommendationData: advisorRecommendationData })
        this.userId = localStorage.getItem('userid')
        this.loadLibrariesForUser(this.userId)
        this.loadGeoIds()
        await this.redirectIfDisabled()
        this.$forceUpdate()
        this.loadLogDashboardActivity({action: 'viewCareerDetail', page: 'careerDetail', link: '', careerSocCode: this.code})
        let growthData = []
        growthData.push(Number(this.formattedCareer.growthOneYear).toFixed(2))
        growthData.push(Number(this.formattedCareer.growthTwoYear).toFixed(2))
        growthData.push(Number(this.formattedCareer.growthThreeYear).toFixed(2))
        growthData.push(Number(this.formattedCareer.growthFiveYear).toFixed(2))
        growthData.push(Number(this.formattedCareer.growthTenYear).toFixed(2))
        this.chartData.datasets[0].data = growthData
        this.chartDataReady = true
      },
      buildTimeRangeLabel (from, to) {
        let monthMap = this.monthMap // maps 0 -> Jan, 1 -> Feb, ....
        // string 'from' is guaranteed to be set from the backend, checking in case
        if (!from) {
          return ''
        }

        // create label prefix in human readable date format instead of UTC
        let dateTime = new Date(from)
        let label = monthMap[dateTime.getMonth()] + ', ' + dateTime.getFullYear() + ' - '

        if (to && to.length && to.length > 0) {
          dateTime = new Date(to)
          label += monthMap[dateTime.getMonth()] + ', ' + dateTime.getFullYear()
        } else {
          label += 'Present'
        }
        return label
      },
      showResumeClicked () {
        this.showResume = !this.showResume
      },
      getLocationParamForCareerSearch () {
        let locationParam = ''
        let selectedState = (this.selectedState && this.selectedState.label) ? this.selectedState.label : null
        let selectedMetroArea = (this.selectedMetroArea && this.selectedMetroArea.label) ? this.selectedMetroArea.label : null
        let selectedCounty = (this.selectedCounty && this.selectedCounty.label) ? this.selectedCounty.label : null

        if (selectedState) {
          locationParam = 'state:' + this.labelsToCodesMap.stateGeoIds[selectedState]
        } else if (selectedMetroArea) {
          locationParam = 'msa:' + this.labelsToCodesMap.msaGeoIds[selectedMetroArea]
        } else if (selectedCounty) {
          locationParam = 'county:' + this.labelsToCodesMap.countyGeoIds[selectedCounty]
        }
        return locationParam
      },
      async careerSearchClicked () {
        let careerCode = this.formattedCareer.code
        let locationParam = this.getLocationParamForCareerSearch()
        if (!locationParam || !careerCode) {
          return
        }
        this.$refs.loadingModal.show()
        await this.loadCareerResult({careerCode: careerCode, locationParam: locationParam})
        this.growthComponentKey += 1
        this.$refs.loadingModal.hide()
        this.$forceUpdate()
      },
      goToProgramGuideDetail (major, cipCodeIndex) {
        let majorCipCode = ''
        this.formattedCareer.cipCodes.forEach((code, i) => {
          if (i === cipCodeIndex) {
            majorCipCode = code
          }
        })
        // TODO this doesn't use 'code', refactor or remove
        return this.$router.push({ name: 'programGuideIntroduction', params: { cipCode: majorCipCode, returnTo: this.returnTo } })
      },
      canAccessEditPage () {
        let permission = this.permission
        if (!permission || !permission.careerPermission) {
          return false
        }
        return permission.careerPermission.write === true
      },
      returnToClicked () {
      	if ((this.returnTo !== this.DEFAULT_RETURN_TO) || (this.returnTo !== this.EXPLORE_RESULTS)) {
      		let routeParams = {
      			code: this.code,
      			cipCode: this.cipCode,
          	programGuideCode: this.programGuideCode,
          	type: this.type,
          	showBackToResultButton: true
      		}
      		return this.$router.push({name: this.returnTo, params: routeParams})
      	}
        return this.$router.push({name: this.returnTo})
      },
      deCamelCase () {
      	if (!this.returnTo) {
          this.returnTo = this.DEFAULT_RETURN_TO
        }
        if (this.returnTo === this.EXPLORE_RESULTS) {
          return 'return to career results'
        }
        if (this.$route.query.returnTo === 'careerIntoduction') {
        	return 'return to career summary'
        }
        let result = this.returnTo.replace(/([A-Z])/g, ' $1')
        return 'return to ' + result
      },
      formatOptionsForVSelect (map) {
        let formatted = []
        Object.keys(map).sort().forEach((key, i) => {
          formatted.push({id: key, label: map[key]})
        })
        formatted.sort((a, b) => (a.label >= b.label) ? 1 : -1)
        return formatted
      },
      resetData () {
        // this ensures the original career object info binds to the ui
        this.genderItems = []
        this.occupationAgeItems = []
        this.educationItems = []
        this.experienceItems = []
        this.topCompaniesItems = []
        this.topSkillsItems = []
        this.genderDonutChartItems = []
        this.occupationAgeDonutChartItems = []
        this.educationDonutChartItems = []
        this.experienceDonutChartItems = []
      },
      parseTerms (sourceList) {
        if (!sourceList || !sourceList.length) {
          return []
        }
        let targetList = []
        let TERM_LIMIT = this.RECOMMENDATION_TERM_LIMIT
        sourceList.forEach((item, i) => {
          if (i < TERM_LIMIT) {
            let curr = JSON.parse(item)
            targetList.push(curr.name)
          }
        })
        return targetList
      },
      buildAlumniStreamRecommendationData (career) {
        let data = {
          'title': career.name,
          'socCode': career.code,
          'topCompanies': this.parseTerms(career.topPostingCompanies),
          'topSkills': this.parseTerms(career.skills),
          'majors': career.majors || [],
          'departments': career.departments || [],
          'category': career.category || ''
        }
        return data
      },
      buildAdvisorStreamRecommendationData (career) {
        let data = {
          'requestType': 'career',
          'relatedCipCodes': career.cipCodes
        }
        return data
      },
      setTitleInitials (entityTitle) {
        let getTitleInitials = entityTitle.match(/\b(\w)/g)
        return getTitleInitials.join('')
      },
      setThumbnailBgColor (entityId) {
        let getNumricValue = entityId.replace(/[^0-9]/g, '')
        return '#' + getNumricValue.slice((getNumricValue.length - 8), (getNumricValue.length - 2))
      },
      showSalaryBoostSkills () {
        $('#careerDetailsSkills').addClass('show_boost_skills_only')
      },
      showAllSkills () {
        $('#careerDetailsSkills').removeClass('show_boost_skills_only')
      },
      setSkillsBarWidth (totalPostings, skillPostings) {
        return ((skillPostings / totalPostings) * 100) + '%'
      },
      getExploreSearchPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getExploreSearchPackage(packages)
      },
      navigateToIntroduction () {
        return this.$router.push({ name: 'careerDetail', params: this.careerRouterParams, query: this.careerQueryParam })
      },
      navigateToPrograms () {
        return this.$router.push({ name: 'careerPrograms', params: this.careerRouterParams, query: this.careerQueryParam })
      },
      navigateToViewStreams () {
        return this.$router.push({ name: 'careerStreams', params: this.careerRouterParams, query: this.careerQueryParam })
      },
      navigateToInsights () {
        return this.$router.push({ name: 'careerInsights', params: this.careerRouterParams, query: this.careerQueryParam })
      },
      async redirectIfDisabled () {
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.introductionTab) {
          return
        }
        if (exploreCareerDetailFlagMap.introductionTab.enabled) {
          return
        }
        if (exploreCareerDetailFlagMap.programsTab.enabled) {
          return this.navigateToPrograms()
        }
        if (exploreCareerDetailFlagMap.streamsTab.enabled) {
          return this.navigateToViewStreams()
        }
        if (exploreCareerDetailFlagMap.alumniInsightsTab.enabled) {
          return this.navigateToInsights()
        }
      },
      calculateStreamSkillProgressClicked (uuid, title, event) {
        this.selectedStreamUuid = uuid
        this.selectedStreamTitle = title
        this.streamSkillProgressTargetId = event.target.id
        this.showStreamSkillProgressPopup = true
      },
      calculateSkillProgressClicked (career, event) {
        this.selectedCareer = career
        this.skillProgressTargetId = event.target.id
        this.showSkillProgressPopup = true
      },
      closeSkillTagsLegendsPopup () {
        this.$refs.skillTagsLegendsPopover.$emit('close')
      },
			showVideoPopup () {
				this.$refs.videoModal.show()
        this.isVideoModalEnable = true
      },
      closeVideoPopup () {
        this.$refs.videoModal.hide()
				this.isVideoModalEnable = false
      }
    },
    computed: {
      ...mapState({
        'career': state => state.career.careerObject,
        'careerResult': state => state.career.careerResultObject,
        'careerOneStopData': state => state.career.careerOneStopInfo,
        'geoIdMap': state => state.career.geoIdMap,
        'permission': state => state.user.permission,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'packages': state => state.institution.packages,
        'institution': state => state.institution.institution,
        'alumniStreamRecommendations': state => state.stream.alumniStreamRecommendations,
        'advisorStreamRecommendations': state => state.stream.advisorStreamRecommendations,
        'planningStream': state => state.dashboard.planningStream
      }),
      careerDataSource () {
        if (this.isBGTFeatureEnabled) {
          return 'Source: Burning Glass. 2018-2028'
        }
        if (this.isLightcastFeatureEnabled) {
          return 'Source: Lightcast. 2023-2033'
        }
        return 'Source: BLS. 2016-2026'
      },
      showMedianIncome () {
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome) {
          return false
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome.enabled
      },
      medianIncomeLabel () {
        const defaultLabel = 'median income'
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome) {
          return defaultLabel
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome.label || defaultLabel
      },
      showJobPostings () {
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryJobPostings) {
          return false
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryJobPostings.enabled
      },
      hideTopCompanies () {
        let exploreProgramDetailFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_CAREER_DETAIL]
        if (exploreProgramDetailFeature && exploreProgramDetailFeature.enabled) {
          let flags = exploreProgramDetailFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'hideTopCompanies') {
              return flags[i].enabled
            }
          }
        }
      return false
    },
      jobPostingsLabel () {
        const defaultLabel = 'job postings'
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryJobPostings) {
          return defaultLabel
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryJobPostings.label || defaultLabel
      },
      showGrowthRate () {
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate) {
          return false
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate.enabled
      },
      growthRateLabel () {
        const defaultLabel = 'growth rate'
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate) {
          return defaultLabel
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate.label || defaultLabel
      },
      careerRouterParams () {
        let routerParams = {
          code: this.code || this.career.pragyaSoc,
          cipCode: this.cipCode,
          returnTo: this.returnTo || this.DEFAULT_RETURN_TO,
          showBackToResultButton: false
        }
        return routerParams
      },
      careerQueryParam () {
        let queryParam = {
          returnTo: this.$route.query.returnTo || this.DEFAULT_RETURN_TO
        }
        return queryParam
      },
      careerOneStopInfo () {
        let careerOneStopData = this.careerOneStopData
        if (!careerOneStopData || !careerOneStopData.uuid) {
          return {}
        }
        let career = _.cloneDeep(careerOneStopData)
        let annualWagePercentiles = []
        let wagePercentileMap = this.wagePercentileMap
        Object.keys(wagePercentileMap).forEach(key => {
          const wage = {}
          wage.key = wagePercentileMap[key]
          wage.value = career[key] || 'N/A'
          annualWagePercentiles.push(wage)
        })
        career.annualWagePercentiles = annualWagePercentiles
        return career
      },
      showPhoneOnCreateAccountModalLabel () {
        let showPhoneFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_PHONE_NUMBER_ON_CREATE_ACCOUNT]
        return showPhoneFeature.label
      },
      isShowPhoneOnCreateAccountModalEnabled () {
        let showPhoneFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_PHONE_NUMBER_ON_CREATE_ACCOUNT]
        return showPhoneFeature && showPhoneFeature.enabled
      },
      isPhoneRequiredOnCreateAccountModal () {
        let showPhoneFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_PHONE_NUMBER_ON_CREATE_ACCOUNT]
        for (var i = 0; i < showPhoneFeature.flags.length; i++) {
          if (showPhoneFeature.flags[i].title === 'phoneNumberRequired') {
            return showPhoneFeature.flags[i].enabled
          }
        }
        return false
      },
      isEMSIFeatureEnabled () {
        let emsiFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_EMSI_SOURCE]
        return emsiFeature && emsiFeature.enabled
      },
      isBGTFeatureEnabled () {
        let bgtFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_BGT_SOURCE]
        return bgtFeature && bgtFeature.enabled
      },
      isLightcastFeatureEnabled () {
        let lightcastFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_LIGHTCAST_SOURCE]
        return lightcastFeature && lightcastFeature.enabled
      },
      exploreCareerDetailFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.EXPLORE_CAREER_DETAIL
        let exploreSearchPackage = this.getExploreSearchPackage()
        return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
      },
      isAlumniStreamRecommendationsEnabled () {
        return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
      },
      isAdvisorStreamRecommendationsEnabled () {
        return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
      },
      streamRecommendationsLabel () {
        const defaultLabel = 'Pathways'
        let streamRecommendationsFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID]
        if (!streamRecommendationsFeature || !streamRecommendationsFeature.label) {
          return defaultLabel
        }
        return streamRecommendationsFeature.label || defaultLabel
      },
      recommendationFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
        let coursePlanningPackage = this.getExploreSearchPackage()
        return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
      },
      advisorStreamRecommendationsToShow () {
        return this.advisorStreamRecommendations.splice(0, 1)
      },
      advisorStreamRecommendationsLabel () {
        const defaultLabel = 'Advisor Streams'
        let recommendationFlagMap = this.recommendationFlagMap
        if (!recommendationFlagMap || !recommendationFlagMap.showAdvisorStreamRecommendations) {
          return defaultLabel
        }
        return recommendationFlagMap.showAdvisorStreamRecommendations.label || defaultLabel
      },
      alumniStreamRecommendationsToShow () {
        return this.alumniStreamRecommendations.splice(0, 1)
      },
      alumniStreamRecommendationsLabel () {
        const defaultLabel = 'Alumni Streams'
        let recommendationFlagMap = this.recommendationFlagMap
        if (!recommendationFlagMap || !recommendationFlagMap.showAlumniStreamRecommendations) {
          return defaultLabel
        }
        return recommendationFlagMap.showAlumniStreamRecommendations.label || defaultLabel
      },
      jobPostingsPieData () {
        let isEMSIFeatureEnabled = this.isEMSIFeatureEnabled
        let isBGTFeatureEnabled = this.isBGTFeatureEnabled
        let isLightcastFeatureEnabled = this.isLightcastFeatureEnabled
        let careerOneStopInfo = this.careerOneStopInfo
        let data = {
          datasets: [
            {
              label: 'Job Postings',
              backgroundColor: '#8db350',
              data: []
            }
          ]
        }
        if (!isEMSIFeatureEnabled && !isBGTFeatureEnabled && !isLightcastFeatureEnabled && careerOneStopInfo && careerOneStopInfo.openings) {
          data.datasets[0].data.push(careerOneStopInfo.openings)
        }
        let formattedCareer = this.formattedCareer
        if ((isEMSIFeatureEnabled || isBGTFeatureEnabled || isLightcastFeatureEnabled) && formattedCareer && formattedCareer.openings) {
          data.datasets[0].data.push(formattedCareer.openings)
        }
        return data
      },
      growthPieData () {
        let data = {
          datasets: [
            {
              labels: 'Growth',
              backgroundColor: ['#f5b518', '#9fc958', '#0a7714'],
              data: [15, 15, 15]
            }
          ]
        }
        if (this.formattedCareer && this.formattedCareer.growth) {
          return data
        }
        return {}
      },
      medianIncomePieData () {
        let isEMSIFeatureEnabled = this.isEMSIFeatureEnabled
        let isBGTFeatureEnabled = this.isBGTFeatureEnabled
        let isLightcastFeatureEnabled = this.isLightcastFeatureEnabled
        let careerOneStopInfo = this.careerOneStopInfo
        let data = {
          datasets: [
            {
              label: 'Median Income',
              backgroundColor: '#8db350',
              data: []
            }
          ]
        }
        if (!isEMSIFeatureEnabled && !isBGTFeatureEnabled && !isLightcastFeatureEnabled && careerOneStopInfo && careerOneStopInfo.medianEarning) {
          data.datasets[0].data.push(careerOneStopInfo.medianEarning)
        }
        let formattedCareer = this.formattedCareer
        if ((isEMSIFeatureEnabled || isBGTFeatureEnabled || isLightcastFeatureEnabled) && formattedCareer && formattedCareer.medianIncomePerYear) {
          data.datasets[0].data.push(formattedCareer.medianIncomePerYear)
        }
        return data
      },
      getThumbnailURI () {
	      return 'https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/soc-' + this.code + '---00.svg'
	    },
      formattedCareer () {
        let formattedCareer = (this.careerResult && this.careerResult.name) ? this.careerResult : this.career
        if (!formattedCareer) {
          return {}
        }
        this.resetData()
        if (formattedCareer.occupationOverview && formattedCareer.occupationOverview.length > 0) {
          formattedCareer.formattedOccupation = JSON.parse(formattedCareer.occupationOverview)
        }
        if (formattedCareer.postingOverview && formattedCareer.postingOverview.length > 0) {
          formattedCareer.formattedPosting = JSON.parse(formattedCareer.postingOverview)
        }
        if (formattedCareer.majors && formattedCareer.majors.length > 0) {
          formattedCareer.majorsLabel = formattedCareer.majors.join(', ')
        }
        if (formattedCareer.departments && formattedCareer.departments.length > 0) {
          formattedCareer.departmentsLabel = formattedCareer.departments.join(', ')
        }
        if (formattedCareer.industries && formattedCareer.industries.length > 0) {
          formattedCareer.industriesLabel = formattedCareer.industries.join(', ')
        }
        if (formattedCareer.percentByGenderWomen && formattedCareer.percentByGenderMen) {
          // set label dynamically from backend to show the year's percentage breakdown
          let genderPercentLabel = 'Percent'
          if (formattedCareer.formattedOccupation && formattedCareer.formattedOccupation.year) {
            genderPercentLabel = formattedCareer.formattedOccupation.year + ' Percent'
          }
          this.genderFields[2] = genderPercentLabel

          // TODO set CSS gender icons/legend in the first slot instead of ''
          let malePercentInfo = {'': '', 'Gender': 'Male'}
          let femalePercentInfo = {'': '', 'Gender': 'Female'}
          malePercentInfo[genderPercentLabel] = formattedCareer.percentByGenderMen
          femalePercentInfo[genderPercentLabel] = formattedCareer.percentByGenderWomen
          this.genderItems.push(malePercentInfo)
          this.genderItems.push(femalePercentInfo)

          this.genderDonutChartItems.push({label: 'Male', value: formattedCareer.percentByGenderMen, color: '#1b9afa'})
          this.genderDonutChartItems.push({label: 'Female', value: formattedCareer.percentByGenderWomen, color: '#d487fa'})
        }
        if (formattedCareer.percentByAge && formattedCareer.percentByAge.length > 0) {
          formattedCareer.percentByAge.forEach((item, i) => {
            let currItem = JSON.parse(item)
            // the backend sends the same 8 age brackets twice, should be fixed at some point
            // but this workaround suffices for now
            if (i <= 7) {
              // TODO put CSS gender icons in the first slot instead of ''
              this.occupationAgeItems.push({' ': '', 'Age': currItem.group, 'Percent': currItem.percent})
              if (currItem.percent > 0) {
                this.occupationAgeDonutChartItems.push({label: currItem.group, value: currItem.percent})
              }
            }
          })
        }
        if (formattedCareer.education && formattedCareer.education.length > 0) {
          formattedCareer.education.forEach((item) => {
            // TODO put CSS gender icons in the first slot instead of ''
            this.educationItems.push({' ': '', 'Education_Level': item.level, 'Percent': item.score})
            if (item.score > 0) {
              this.educationDonutChartItems.push({label: item.level, value: item.score - 0.01}) // sum of all elements has to be strictly < 100
            }
          })
        }
        if (formattedCareer.experience && formattedCareer.experience.length > 0) {
          formattedCareer.experience.forEach((item) => {
            // TODO put CSS gender icons in the first slot instead of ''
            this.experienceItems.push({' ': '', 'Experience_Level': item.level, 'Percent': item.score})
            if (item.score > 0) {
              this.experienceDonutChartItems.push({label: item.level, value: item.score - 0.01}) // sum of all elements has to be strictly < 100
            }
          })
        }
        if (formattedCareer.topPostingCompanies && formattedCareer.topPostingCompanies.length > 0) {
          formattedCareer.topPostingCompanies.forEach((item) => {
            let currItem = JSON.parse(item)
            this.topCompaniesItems.push({
              'Company': currItem.name,
              'Total': (currItem.total_postings),
              'Unique': (currItem.unique_postings),
              'Posting_Intensity': (Math.round(currItem.posting_intensity) + ':1')
            })
          })
          this.topCompaniesItems = this.topCompaniesItems.sort((a, b) => (Number(a.Total) <= Number(b.Total)) ? 1 : -1)
        }
        let isEMSIFeatureEnabled = this.isEMSIFeatureEnabled
        let isBGTFeatureEnabled = this.isBGTFeatureEnabled
        let isLightcastFeatureEnabled = this.isLightcastFeatureEnabled
        let hasEMSISkills = formattedCareer.skills && formattedCareer.skills.length
        let hasONETSkills = formattedCareer.careerSkills && formattedCareer.careerSkills.length
        if ((isEMSIFeatureEnabled || isBGTFeatureEnabled || isLightcastFeatureEnabled) && hasEMSISkills) {
          formattedCareer.skills.forEach((item) => {
            let currItem = JSON.parse(item)
            this.topSkillsItems.push({
              'Skill': currItem.name,
              'Postings_with_Skill': currItem.unique_postings,
              'Types': currItem.types,
              'Marginal_Value': currItem.marginal_value
            })
          })
          this.topSkillsItems = this.topSkillsItems.sort((a, b) => (Number(a.Postings_with_Skill) <= Number(b.Postings_with_Skill)) ? 1 : -1)
        }
        if (!isEMSIFeatureEnabled && !isBGTFeatureEnabled && !isLightcastFeatureEnabled && hasONETSkills) {
          let knowledges = []
          let skills = []
          let abilities = []
          formattedCareer.careerSkills.forEach(careerSkill => {
            let title = careerSkill.title
            if (careerSkill.type === 'KNOWLEDGE') {
              knowledges.push(title)
            }
            if (careerSkill.type === 'SKILL') {
              skills.push(title)
            }
            if (careerSkill.type === 'ABILITY') {
              abilities.push(title)
            }
          })
          formattedCareer.knowledgeLabel = knowledges
          formattedCareer.topSkillsLabel = skills
          formattedCareer.abilitiesLabel = abilities
        }
        if (!this.career.thumbnailURI) {
        	this.career.thumbnailURI = this.getThumbnailURI
        }
        formattedCareer.thumbnailURI = this.career.thumbnailURI
        return formattedCareer
      },
      formattedGeoIdMap () {
        let formattedMap = {}
        let map = this.geoIdMap

        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = this.formatOptionsForVSelect(map.stateGeoIds)
          formattedMap.msaGeoIds = this.formatOptionsForVSelect(map.msaGeoIds)
          formattedMap.countyGeoIds = this.formatOptionsForVSelect(map.countyGeoIds)
        }
        return formattedMap
      },
      labelsToCodesMap () {
        let map = this.geoIdMap
        let formattedMap = {}
        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = _.invert(map.stateGeoIds)
          formattedMap.msaGeoIds = _.invert(map.msaGeoIds)
          formattedMap.countyGeoIds = _.invert(map.countyGeoIds)
        }
        return formattedMap
      },
      showRecommendationsTab () {
        return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
      },
      isRecommendationFeatureEnabled () {
        let recommendationsFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID]
        if (recommendationsFeature) {
          return recommendationsFeature.enabled
        }
        return false
      },
      currencyLabel () {
        return '$'
      },
      isCareerSkillProgressEnabled () {
        let path = this.$router.currentRoute.fullPath
        let isPathwaysTab = (path.indexOf('streams') !== -1)
        if (isPathwaysTab) {
          return false
        }
        let recommendationFlagMap = this.recommendationFlagMap
        if (!recommendationFlagMap || !recommendationFlagMap.showCareerSkillProgress) {
          return false
        }
        return recommendationFlagMap.showCareerSkillProgress.enabled
      },
      exploreCareersFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.EXPLORE_CAREERS
        let exploreSearchPackage = this.getExploreSearchPackage()
        return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
      },
      showCalculateRequiredSkillOnResult () {
        let exploreCareersFlagMap = this.exploreCareersFlagMap
        if (!exploreCareersFlagMap || !exploreCareersFlagMap.searchResultCalculateRequiredSkill) {
          return false
        }
        return exploreCareersFlagMap.searchResultCalculateRequiredSkill.enabled
      },
      isStudentLogin () {
        return (localStorage.getItem('userrole') === 'Student')
      }
    },
    watch: {
      selectedState (newState) {
        if (!newState) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
          this.disableSelectCounty = false
          this.loadDataForCareerDetail()
          this.isSalaryBoostSkill = false
        } else {
          this.disableSelectState = false
          this.disableSelectMetroArea = true
          this.disableSelectCounty = true
        }
        this.$forceUpdate()
      },
      selectedMetroArea (newMSA) {
        if (!newMSA) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
          this.disableSelectCounty = false
          this.loadDataForCareerDetail()
          this.isSalaryBoostSkill = false
        } else {
          this.disableSelectState = true
          this.disableSelectMetroArea = false
          this.disableSelectCounty = true
        }
        this.$forceUpdate()
      },
      selectedCounty (newCounty) {
        if (!newCounty) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
          this.disableSelectCounty = false
        } else {
          this.disableSelectState = true
          this.disableSelectMetroArea = true
          this.disableSelectCounty = false
        }
      }
    }
  }
</script>

<style scoped>
    .pointer {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerDetail.vue